import React, {useEffect, useState, useContext, useRef, forwardRef, useMemo, Suspense, lazy, useCallback} from 'react'
import jwt_decode from 'jwt-decode'
// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  Backdrop,
  Fade,
  Modal,
  IconButton,
  Slide,
  Stack,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Avatar,
  Card,
  CardContent,
  Paper,
  CircularProgress,
  Divider
} from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close'
import {makeStyles} from '@material-ui/styles'
import OtpInput from 'react-otp-input';
// components
import Page from '../components/Page'
import {useSnackbar} from 'notistack5'
import {SocketContext} from 'utils/context/socket'
import {useNavigate} from 'react-router-dom'
import PromotionDialog from 'components/promotionDialog'
import {BreakOut, BreakIn, TimeIn, TimeOut, Completed, Loading, BreakSwitch} from 'components/timeButton'
import diceGameApi from 'utils/api/diceGame'
import LocationLoading from 'components/timeButton/LocationLoading'
import HelpButton from 'components/discord'
import FacebookDialog from 'components/facebookDialog'
import page404 from 'pages/Page404'
import {LazyLoadImage} from 'react-lazy-load-image-component'
import user_api from 'utils/api/users'
import storage from 'utils/storage'
import Clock from 'react-live-clock'
import Bugsnag from '@bugsnag/js'
import QrReader from 'react-qr-reader'
import QRCode from 'qrcode.react'
import UAParser from 'ua-parser-js'
import '../assets/css/horizontal.css'
import GenerateQR from '../assets/svg/QRCODE.svg'
import Workmate from '../assets/svg/WORKMATE.svg'
import BreakInFalse from '../assets/svg/breakTime.png'
import Carousel from 'nuka-carousel'
import {ConnectingAirportsOutlined, HighlightOff as HighlightOffIcon} from '@mui/icons-material'
import {alpha, useTheme} from '@material-ui/core/styles'
import {Icon} from '@iconify/react'
import useMediaQuery from '@mui/material/useMediaQuery'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import StorefrontIcon from '@mui/icons-material/Storefront'
import QrCodeIcon from '@mui/icons-material/QrCode'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import SecureLS from 'secure-ls'
import { addDays } from 'date-fns'
import EditIcon from '@mui/icons-material/Edit'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {FacebookProvider, CustomChat} from 'react-facebook'
import { WorkmateTimeinProvider, useWorkmateTimein } from 'utils/context/workmateTimein';
import HistoryIcon from '@mui/icons-material/History';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';
import { useAuth } from 'components/SessionAuth'
import { tourSteps } from 'components/DashboardTour'
import DemoRestrictionDialog from 'components/timeButton/DemoRestrictionDialog';
import DiceGameDialog from 'components/diceGame/DiceGameDialog';
const ls = new SecureLS({encodingType: 'aes'})
// ----------------------------------------------------------------------
const moment = require('moment-timezone')
const SurveyForm = lazy(() => import('components/surveyForm'))
moment().tz('Asia/Manila').format()
const current_date = `${moment().tz('Asia/Manila').toISOString(true)}`

let parser = new UAParser()
let browser = parser.getBrowser()

const useStyles = makeStyles({
  customWidth: {
    width: '80%',
    height: '50%',
  },
  historyCard: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    border: '1px solid #2194F3',
    borderRadius: '8px',
  },
})

const dummyCurrentShift = [
  {
    id: '65c02c8e1699de002ec1ab2c',
    timeStatus: 'Time in',
    time: '08:54 AM',
    date: 'Mon, Feb 05',
  },
  {
    id: '65c02c8e1699de002ec1ab2d',
    timeStatus: 'Break in',
    time: '00:00',
    date: '',
  },
  {
    id: '65c02c8e1699de002ec1ab2e',
    timeStatus: 'Break out',
    time: '00:00',
    date: '',
  },
  {
    id: '65c02c8e1699de002ec1ab2f',
    timeStatus: 'Time out',
    time: '05:05 PM',
    date: 'Mon, Feb 05',
  },
]
const dummyStoreCheckList = [
  'I hereby declare that I am physically present upon signing in. Furthermore, I ackknowledge that I have:',
  'An appropriate attire and ID.',
  'Planned to do list/Completed all the task.',
  "Review all GC's and provide feedback",
]

const DashboardApp = () => {
  const { isAuthenticated } = useAuth()
  const theme = useTheme();
  const classes = useStyles()
  let today = new Date(current_date)
  const navigate = useNavigate()
  const [isDemo, setDemo] = useState(false)

  const socket = useContext(SocketContext)
  const [status, setStatus] = useState(null)
  const [switchTimeBreak, setSwitchTimeBreak] = useState(false)
  const [curStatus, setCurStatus] = useState(null)
  const [workmateStatus, setWorkmateStatus] = useState(null)
  const [currentDate, setCurrentDate] = useState(null)
  const [user, setUser] = useState({})
  const [userData, setUserData] = useState({})
  const [basicUser, setBasicUser] = useState({})
  const [report, setReport] = useState({})
  const [workmateReport, setWorkmateReport] = useState({})
  const [isLoading, setLoading] = useState()
  const [totalHours, setTotalHours] = useState(0)
  const [value, setValue] = useState(null)
  const [validated, setValidated] = useState(false)
  const [validatedChecklist, setValidatedChecklist] = useState(false)
  // const [vacCheckBoxChange, setVacCheckboxChange] = useState(false)
  // const [groomingCheckboxChange, setGroomingCheckboxChange] = useState(false)
  // const [nameplateCheckBoxChange, setNameplateCheckboxChange] = useState(false)
  // const [uniformCheckboxChange, setUniformCheckboxChange] = useState(false)
  const [acknowledged, setAcknowledged] = useState(false)
  // const [checkBoxChange, setCheckboxChange] = useState(false)
  const [saveScheduleSuccess, setSaveScheduleSuccess] = useState(false)
  const [savePremiumDialog, setSavePremiumDialog] = useState(false)
  const [id, setId] = useState('')
  const [stream, setStream] = useState()
  const [scanMessage, setScanMessage] = useState('No data found')
  const [name, setName] = useState('')
  const [ip, setIp] = useState('')
  const [openQR, setOpenQR] = useState(false)
  const [storeLoc, setStoreLocation] = useState(false)
  const [openWorkmateTimein, setOpenWorkmateTimein] = useState(false)
  const [openTimein, setOpenTimein] = useState(false)
  const [captureStatus, setCaptureStatus] = useState(false)
  const [timeinStatus, setTimeinStatus] = useState(true)
  const [successStatus, setSuccessStatus] = useState(true)
  const [workmateChecklist, setWorkmateChecklist] = useState(true)
  const {enqueueSnackbar} = useSnackbar()
  const [selected, setSelected] = useState(false)
/*  const [inputOtpDialog, setInputOtpDialog] = useState(false)*/
  const [selectedBanner, setSelectedBanner] = useState(false)
  const [confirmSchedule, setConfirmSchedule] = useState(false)
  const [from, setFrom] = useState(new Date())
  const [to, setTo] = useState(new Date())
  const [breakMin, setBreakMin] = useState(0)
  const [ot, setOt] = useState(0)
  const [nsd, setNsd] = useState(0)
  const [position, setPosition] = useState("")
  const [qrUser, setQrUser] = useState({})
  const [banners, setBanners] = useState([])
  const [broadcast, setBroadcast] = useState([])
  const [checklists, setChecklists] = useState([
    'I testify that I am in front of the TS and management representative upon signing in. Also, I signify that I have:',
    'Complete uniform.',
    'Name plate.',
    'Proper grooming.',
    'Vaccination card.',
  ])
  // const [coc, setCoc] = useState({})
  const [total, setTotal] = useState()
  const [surveyDone, setSurveyDone] = useState()
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [mySchedule, setMySchedule] = useState(false)
  const [myPremiumValues, setMyPremiumValues] = useState(false)
  const [openEditCompany, setOpenEditCompany] = useState(false)
  const [otpDialog, setOtpDialog] = useState(false)
  const [diceGameDialog, setDiceGameDialog] = useState(false)
  const [otp, setOtp] = useState('')
  const [currentRecordDate, setCurrentRecordDate] = useState()
  const [currentRecord, setCurrentRecord] = useState()
  const [previousLocation, setPreviousLocation] = useState(null)
  const [loadingBanner, setLoadingBanner] = useState(false)
  const [bannerStatus, setBannerStatus] = useState(false)
  const [checklistToggle, setChecklistToggle] = useState(true)
  const [specificSchedule, setSpecificSchedule] = useState({})
  /*  const [newFirstName, setNewFirstName] = useState('')
  const [newLastName, setNewLastName] = useState('')*/
  const [appVersion, setAppVersion] = useState(process.env.REACT_APP_VERSION)
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  })
  const [promotionDialogState, setpromotionDialogState] = useState({
    showDialog: false,
    promotion: {},
  })
  const [open, setOpen] = useState(false)
  const [otMinutes, setOtMinutes] = useState(0)
  const [nsdMinutes, setNsdMinutes] = useState(0)
  const [otHours, setOtHours] = useState(0)
  const [nsdHours, setNsdHours] = useState(0)
  const [openSetOTDialog, setOpenSetOTDialog] = useState(false)
  const [dialogStatus, setDialogStatus] = useState(false)
  const [openCurrentShift, setCurrentShift] = useState(false)
  const [openAcknowledgement, setOpenAcknowledegment] = useState(false)
  const [initialBanner, setInitialBanner] = useState('')
  const [openOtherStore, setOpenOtherStore] = useState(false)
  const [checkOtherStore, setOtherStore] = useState(false)
  const [updateDialogOpen, setUpdateDialogOpen] = useState(true);
  const [checkSchedule, setCheckSchedule] = useState(false);
  const [breakMinSpecific, setBreakMinSpecific] = useState();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0] // Ensures correct format
  );
  const [confirmScheduleDialog, setConfirmScheduleDialog] = useState(false);
  const [openConfirmScheduleDialog, setOpenConfirmScheduleDialog] = useState(false);
  const [openCreateScheduleDialog, setOpenCreateScheduleDialog] = useState(false);
  const [noScheduleDialog, setNoScheduleDialog] = useState(false);
  const streamRef = useRef(null)
  /*  const [videoStatus, setVideoStatus] = useState(false)
    const [canvasStatus, setCanvasStatus] = useState(true)*/
  let videoRef = useRef(null)
  let photoRef = useRef(null)
  let browserName = browser.name
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  const { isWorkmateTimeinOpen, closeWorkmateTimein } = useWorkmateTimein();
  const [userTimedOut, setUserTimedOut] = useState(false)
  const [isFutureSchedule, setIsFutureSchedule] = useState(false)
  const [scheduleDate, setScheduleDate] = useState('')
  const [noUnconfirmedSchedules, setNoUnconfirmedSchedules] = useState(false)
  const [recentRecords, setRecentRecords] = useState([]);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [expandedCards, setExpandedCards] = useState({});
  const [isEditingExistingSchedule, setIsEditingExistingSchedule] = useState(false);
  const [cameraRetryCount, setCameraRetryCount] = useState(0);
  const [isScheduleConfirmation, setIsScheduleConfirmation] = useState(false)
  const [demoDialogOpen, setDemoDialogOpen] = useState(false);
  const [tooEarlyDialogOpen, setTooEarlyDialogOpen] = useState(false);
  const [cameraInitStarted, setCameraInitStarted] = useState(false)
  const [cameraReady, setCameraReady] = useState(false)
  const [waitingForCamera, setWaitingForCamera] = useState(false)
  const [cameraStatusDelayPassed, setCameraStatusDelayPassed] = useState(false)
  const [qrReaderDelayActive, setQrReaderDelayActive] = useState(false)
  const [qrReaderLegacyMode, setQrReaderLegacyMode] = useState(false)
  const [qrReaderErrorMessage, setQrReaderErrorMessage] = useState('')
  const [qrReaderRetryCount, setQrReaderRetryCount] = useState(0)

  // Custom media query for screens below 400px
  const isVerySmallScreen = useMediaQuery('(max-width:350px)');

  const handleVideoReady = useCallback(() => {
    const video = videoRef.current;
    if (video && video.srcObject) {
      console.log('Camera ready - srcObject exists');
      setCameraReady(true)
      setWaitingForCamera(false)
    }
  }, [])

  useEffect(() => {
    if (!cameraInitStarted || !videoRef.current) {
      return
    }

    const videoElement = videoRef.current
    const events = ['loadeddata', 'loadedmetadata', 'playing', 'canplay', 'canplaythrough']

    events.forEach((event) => {
      videoElement.addEventListener(event, handleVideoReady)
    })

    // Poll to check if srcObject exists (fallback in case events don't fire)
    const checkInterval = setInterval(() => {
      const video = videoRef.current;
      if (video && video.srcObject && !cameraReady) {
        console.log('Camera detected via polling - srcObject exists');
        handleVideoReady();
      }
    }, 500);

    return () => {
      clearInterval(checkInterval);
      events.forEach((event) => {
        videoElement.removeEventListener(event, handleVideoReady)
      })
    }
  }, [cameraInitStarted, handleVideoReady, cameraReady])

  useEffect(() => {
    if (!cameraInitStarted) {
      setCameraReady(false)
    }
  }, [cameraInitStarted])

  const isCameraOutputMissing = cameraInitStarted && !cameraReady

  const qrReaderRef = useRef(null)
  const qrReaderDelay = qrReaderDelayActive ? 500 : false
  const qrReaderConstraints = useMemo(
    () => ({
      audio: false,
      video: {
        facingMode: isMobile ? {ideal: 'environment'} : 'environment',
        width: {ideal: 1920},
        height: {ideal: 1080},
      },
    }),
    [isMobile],
  )

  const handleQrReaderLoad = useCallback(() => {
    setQrReaderDelayActive(true)
    setQrReaderLegacyMode(false)
    setQrReaderErrorMessage('')
  }, [])

  const handleQrReaderError = useCallback((error) => {
    console.error('QR Reader error:', error)
    setQrReaderDelayActive(false)
    setQrReaderLegacyMode(true)
    setQrReaderErrorMessage(
      error?.message ||
        'Unable to access the camera. You can upload a QR code image instead.',
    )
    setQrReaderRetryCount((prev) => prev + 1)
  }, [])

  const resetQrReaderState = useCallback(() => {
    setQrReaderDelayActive(false)
    setQrReaderLegacyMode(false)
    setQrReaderErrorMessage('')
    setQrReaderRetryCount(0)
  }, [])
  
  // Effect to listen for changes in isWorkmateTimeinOpen
  useEffect(() => {
    if (isWorkmateTimeinOpen) {
      handleOpenWorkmateTimein();
      closeWorkmateTimein();
    }
  }, [isWorkmateTimeinOpen]);

  // Effect to reset camera retry count when dialogs are closed
  useEffect(() => {
    if (!openTimein && !openWorkmateTimein) {
      setCameraRetryCount(0);
      setCameraInitStarted(false)
      setCameraReady(false)
      setWaitingForCamera(false)
      resetQrReaderState()
      setQrReaderRetryCount(0)
    }
  }, [openTimein, openWorkmateTimein]);
  
  useEffect(() => {
    let timer;
    if (openConfirmScheduleDialog) {
      setCountdown(5); // Reset countdown when dialog opens
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            setOpenConfirmScheduleDialog(false);
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    } 

    else if (openTimein && !captureStatus) {
      
      setWaitingForCamera(true);
      
      const video = videoRef.current;
      const hasCameraStream = video && video.srcObject !== null;
        
      if (hasCameraStream) {
        // Camera stream exists, take picture
        setCountdown(5);
        timer = setInterval(() => {
          setCountdown((prev) => {
            // Check if camera stream exists (srcObject is not null)
            
            if (prev === 1) {
              takePicture();
              clearInterval(timer);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        return () => clearInterval(timer);
      }
    }
    else {
      setCountdown(5)
      return () => clearInterval(timer);
    }
    setLoading(false)
  }, [openConfirmScheduleDialog, openTimein, captureStatus, cameraReady]);

  // Auto-capture when camera stream becomes available while waiting
  useEffect(() => {
    if (!waitingForCamera || !openTimein || captureStatus) {
      return;
    }

    // Poll every 1000ms to check if camera stream is available
    const pollInterval = setInterval(() => {
      const video = videoRef.current;
      const hasCameraStream = video && video.srcObject !== null;

      if (hasCameraStream) {
        setWaitingForCamera(false);
        setCameraReady(true);
        clearInterval(pollInterval);
      }
    }, 1000);

    // Add timeout to prevent infinite waiting (30 seconds max)
    const timeoutId = setTimeout(() => {
      console.warn('Camera waiting timeout reached, resetting camera state');
      clearInterval(pollInterval);
      setWaitingForCamera(false);
      setCameraReady(false);
      setCameraInitStarted(false);

      getVideo('running');
    }, 5000);

    return () => {
      clearInterval(pollInterval);
      clearTimeout(timeoutId);
    };
  }, [waitingForCamera, openTimein, captureStatus]);

  useEffect(() => {
    if (basicUser && basicUser._id) {
      // Fetch recent records when component loads or userId changes
      fetchRecentRecords(basicUser._id);
    }
  }, [basicUser._id]);

  const renderTime = (_time) => {
    let _date = new Date(_time)
    /*    var hours = _date.getHours()
        var minutes = _date.getMinutes()
        var ampm = hours >= 12 ? 'pm' : 'am'
        hours = hours % 12
        hours = hours ? hours : 12 // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes
        var strTime = hours + ':' + minutes + ' ' + ampm
        const phTime = moment.tz(strTime, 'h:mm A', 'Asia/Manila')*/
    const userTimeZone = moment.tz.guess()
    const userLocalTime = _date.toLocaleString('en-US', {timeZone: userTimeZone, hour: 'numeric', minute: '2-digit'})
    return userLocalTime
    //return strTime
  }

  const filterByStatus = (_data, type) => {
    let _d = _data.filter((_d) => (_d.status === type ? _d : ''))
    if (_d.length > 0) {
      _d = _d[0]
    }
    if (_d) {
      if (typeof _d.time === 'string') {
        return {
          time: _d.time === undefined ? 'n/a' : _d.time,
          _longitude: _d.location === undefined ? '' : _d.location.longitude,
          _latitude: _d.location === undefined ? 'n/a' : _d.location.latitude,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )',
        }
      } else {
        return {
          time: _d.time === undefined ? 'n/a' : renderTime(_d.time),
          _longitude: _d.location === undefined ? '' : _d.location.longitude,
          _latitude: _d.location === undefined ? 'n/a' : _d.location.latitude,
          workmate: _d.workmate === undefined ? '' : 'Workmate( ' + _d.workmate + ' )',
        }
      }
    } else {
      return '-'
    }
  }

  const handleCloseUpdateDialog = () => {
    window.location.reload()
    setUpdateDialogOpen(false)
  }
  const load = async () => {
    setLoading(true)
    const storedVersion = ls.get('appVersion')

    // Check if running in webview
    const isWebView =
      navigator.userAgent.includes('wv') ||
      (navigator.userAgent.includes('Mobile/') && !navigator.userAgent.includes('Safari'))
      
    // Detect platform - Android or iOS
    const isAndroid = /android/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (storedVersion === undefined || storedVersion === null || storedVersion === '' || storedVersion !== appVersion) 
    {
      setUpdateDialogOpen(true)
    }
    else {
      setUpdateDialogOpen(false)
    }
    ls.set('appVersion', appVersion)  
    
    try {
      const latFromLS = ls.get('latitude');
      const longFromLS = ls.get('longitude');
      
      // Handle location based on environment (Native vs Browser) and platform (Android vs iOS)
      // if (window.ReactNativeWebView) {
      //   // For React Native WebView
      //   try {
      //     // Platform specific message for location request
      //     const platformMessage = isAndroid 
      //       ? { type: 'GET_LOCATION', platform: 'android' }
      //       : { type: 'GET_LOCATION', platform: 'ios' };
            
      //     window.ReactNativeWebView.postMessage(JSON.stringify(platformMessage));
          
      //     // Set up listener for the response
      //     window.addEventListener('message', function locationListener(event) {
      //       try {
      //         const data = JSON.parse(event.data);
      //         if (data.type === 'LOCATION_RESULT') {
      //           if (data.error) {
      //             console.error("Native location error:", data.error);
                  
      //             // Platform-specific guidance for enabling location
      //             if (isAndroid) {
      //               alert("Location services are disabled. On Android, please go to Settings > Location and enable location services.");
      //             } else if (isIOS) {
      //               alert("Location services are disabled. On iOS, please go to Settings > Privacy > Location Services and enable for this app.");
      //             } else {
      //               alert("Location services are disabled. Please enable location in your device settings to use the time-in feature.");
      //             }
                  
      //             // Try to use cached location if available
      //             if (latFromLS && longFromLS && parseFloat(latFromLS) !== 0 && parseFloat(longFromLS) !== 0) {
      //               setLocation({ latitude: parseFloat(latFromLS), longitude: parseFloat(longFromLS) });
      //             }
      //           } else if (data.coords) {
      //             const { latitude, longitude } = data.coords;
      //             setLocation({ latitude, longitude });
      //             ls.set('latitude', latitude.toString());
      //             ls.set('longitude', longitude.toString());
      //           }
                
      //           // Remove the event listener after processing
      //           window.removeEventListener('message', locationListener);
      //         }
      //       } catch (error) {
      //         console.error("Error processing location from native app:", error);
      //       }
      //     });
      //   } catch (error) {
      //     console.error("Error requesting location from native app:", error);
      //     alert("Unable to request location from the app. Please check your location settings and try again.");
      //   }
      // } else 
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          
        }, (error) => {
          console.log("error", error);
          if (!(isIOS && (error.code === 1 || error.code === 3))) {
            alert("Please turn on location services");
          }
        });
      } else {
        if (!isIOS) {
          alert("Please turn on location services");
        }
      }
      
      if (latFromLS && longFromLS && parseFloat(latFromLS) !== 0 && parseFloat(longFromLS) !== 0) {
        const cachedLocation = { latitude: parseFloat(latFromLS), longitude: parseFloat(longFromLS) };
        setLocation(cachedLocation);
      } else {
        // Add timeout protection for geolocation call to prevent app hanging
        try {
          const locationResult = await Promise.race([
            geolocation(),
            new Promise((resolve, reject) => 
              setTimeout(() => {
                console.warn('Geolocation in load function timed out, using default location');
                const defaultLocation = { latitude: 0, longitude: 0 };
                setLocation(defaultLocation);
                resolve(defaultLocation);
              }, isIOS ? 8000 : 15000) // Shorter timeout for iOS
            )
          ]);
          console.log('Location initialized:', locationResult);
        } catch (error) {
          console.warn("Geolocation failed during load, continuing with default location:", error);
          const defaultLocation = { latitude: 0, longitude: 0 };
          setLocation(defaultLocation);
        }
      }
    } catch (error) {
        console.warn("Failed to initialize location during load:", error);
        // Set a default location to ensure app continues loading
        const defaultLocation = { latitude: 0, longitude: 0 };
        setLocation(defaultLocation);
    }

    const token = await storage.getToken()
    const getUser = await storage.getUser()
    if (!getUser) {
      window.location.href = '/login'
    }
    const user = JSON.parse(getUser)
    
    // Get fresh user data from API - this covers both cases (user._id and jwt token id should be the same)
    const userFromApi = await user_api.get_user(user._id)
    
    if (user.company === undefined) {
      // If company is undefined in stored user, use the fresh data from API
      if (userFromApi.data.company) {
        user.company = userFromApi.data.company
      } else {
        // Fallback: get user by token ID if still no company
        const inuser = await user_api.get_user(jwt_decode(token)['id'])
        if (inuser.data.company) {
          user.company = inuser.data.company
        }
      }
    }
    
    if (user.company) {
      await handleStatus(user._id)
      setLoading(false)
      const data = {
        company: user.company,
      }
      // const getCoc = await user_api.get_company_coc(data)
      // if (getCoc.data !== null) {
      //   setCoc(getCoc.data.link)
      // }
    }
    if (!user._id) {
      alert('Something went wrong please try again')
    } else {
      const result = await user_api.get_limited_users(user._id)
      if (result.data.msg !== 'No Records') {
        const resultDate = moment(result.data[0].date)
        const currentDate = moment()
        if (!resultDate.isSame(currentDate, 'day')) {
          setCurrentRecord(null)
        }
        else {
           setCurrentRecord(result.data[0])
           const timeIn = filterByStatus(result.data[0].record, 'time-in').time
           const timeOut = filterByStatus(result.data[0].record, 'time-out').time
           if(timeOut === "n/a") {
             setTotal("n/a")
           }
           else {
             const timeOutDate = moment(timeOut, "h:mm A").toDate()
             const timeInDate = moment(timeIn, "h:mm A").toDate()
             const diffInHours = moment.duration(timeOutDate.getTime() - timeInDate.getTime()).asHours();
             setTotal(diffInHours)
             setSurveyDone(userFromApi.data.survey_done) 
             
           }
           /*const timeDifference = await getTimeDifference(result.data[0]);*/
  
        }
      } else {
        setCurrentRecord(null)
      }
    }


    setBasicUser(userFromApi.data)
    const current_date = new Date()
    if (!token) {
      await storage.remove()
      return navigate('/login')
    }
    // Removed redundant user_api.get_user call - we already have userFromApi
    // const company = {
    //   company: user.company,
    // }
    if (!user) {
      await storage.remove()
      return navigate('/login')
    }

    /*    const version = await user_api.get_storyblok_version()
        const bannerRequest = await user_api.get_storyblok_banners(version)
        setBanners(bannerRequest.data.story.content.slide)
        setUser(inuser.data)*/

    // Check if user is eligible for dice game (Syzygy, Jasem, 7-Star)
    // Exclude companies with 'inhouse' in their name (case-insensitive)
    const isInHouseCompany = user.company && user.company.toLowerCase().includes('inhouse');
    const eligibleCompanies = ['Syzygy', 'Jasem', '7-Star'];
    const isEligibleForDiceGame = !isInHouseCompany && user.company && eligibleCompanies.some(company =>
      user.company.toLowerCase().includes(company.toLowerCase())
    );

    const result = await diceGameApi.get_dice_game_stats(user.company)
    let winnerCount = result.data?.stats?.totalWinners
    let isWithinWinnerLimit = true;
    if (user.company?.toLowerCase() === '7-star') {
      isWithinWinnerLimit = winnerCount >= 75;
    } else if (user.company?.toLowerCase() === 'syzygy') {
      isWithinWinnerLimit = winnerCount >= 50;
    }
    else {
      isWithinWinnerLimit = winnerCount >= 30;
    }

    /*
    if (isEligibleForDiceGame && user._id && !isWithinWinnerLimit) {
      try {
        const diceGameApi = (await import('utils/api/diceGame')).default;
        const playedCheck = await diceGameApi.check_user_played_today(user._id);

        if (playedCheck.data.success && !playedCheck.data.hasPlayed) {
          // User hasn't played today, open the dialog
          setTimeout(() => {
            setDiceGameDialog(true);
          }, 1000); // Delay to ensure page is fully loaded
        }
      } catch (error) {
        console.error('Error checking dice game eligibility:', error);
      }
    }
    */
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  useEffect(() => {
    if (browserName.includes('Facebook')) {
      setOpen(true)
    }

    load()
  }, [dialogStatus])

  useEffect(() => {
    if (
      // vacCheckBoxChange &&
      // groomingCheckboxChange &&
      // nameplateCheckBoxChange &&
      // uniformCheckboxChange &&
      // checkBoxChange
      acknowledged && !isScheduleConfirmation // Only start video for time-in acknowledgment, not schedule confirmation
    ) {
      getVideo('running')
      setValidatedChecklist(true)
    }
  }, [acknowledged, isScheduleConfirmation])

  useEffect(() => {
    // setUniformCheckboxChange(false)
    // setNameplateCheckboxChange(false)
    // setGroomingCheckboxChange(false)
    // setVacCheckboxChange(false)
    // setCheckboxChange(false)
    setAcknowledged(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogStatus])

  const geolocation = async () => {
    return new Promise((resolve, reject) => {
      // Add shorter timeout specifically for iOS Safari compatibility
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const timeoutDuration = isIOS ? 10000 : 20000; // Shorter timeout for iOS
      
      if (navigator.geolocation) {
        // Set up timeout to prevent hanging
        const timeoutId = setTimeout(() => {
          console.warn('Geolocation request timed out');
          const lat = ls.get('latitude');
          const long = ls.get('longitude');
          if (lat && long && parseFloat(lat) !== 0 && parseFloat(long) !== 0) {
            const cachedLocation = { latitude: parseFloat(lat), longitude: parseFloat(long) };
            setLocation(cachedLocation);
            resolve(cachedLocation);
          } else {
            console.warn('No cached location available, using default');
            const defaultLocation = { latitude: 0, longitude: 0 };
            setLocation(defaultLocation);
            resolve(defaultLocation);
          }
        }, timeoutDuration);

        navigator.geolocation.getCurrentPosition(
          (position) => {
            clearTimeout(timeoutId);
            const newLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            setLocation(newLocation); // Update component state
            ls.set('latitude', newLocation.latitude.toString()); // Store in SecureLS
            ls.set('longitude', newLocation.longitude.toString()); // Store in SecureLS
            resolve(newLocation);
          },
          (error) => {
            clearTimeout(timeoutId);
            console.log("Error getting location: ", error);
            
            // Don't show alert on iOS Safari if it's a timeout or permission denied in private browsing
            if (!(isIOS && (error.code === 1 || error.code === 3))) {
              alert("Please turn on location services and try again.");
            }
            
            console.error("Error getting location: ", error);
            const lat = ls.get('latitude');
            const long = ls.get('longitude');
            if (lat && long && parseFloat(lat) !== 0 && parseFloat(long) !== 0) {
              const cachedLocation = { latitude: parseFloat(lat), longitude: parseFloat(long) };
              setLocation(cachedLocation); // Update component state with cached
              resolve(cachedLocation); 
            } else {
              if (!isIOS) {
                alert('Failed to get location. Please ensure location services are enabled, permissions are granted, and try refreshing.');
              }
              // Use default location to prevent app from hanging
              const defaultLocation = { latitude: 0, longitude: 0 };
              setLocation(defaultLocation);
              resolve(defaultLocation); // Resolve instead of reject to prevent app hanging
            }
          },
          { 
            enableHighAccuracy: true, 
            timeout: timeoutDuration - 1000, // Slightly less than our manual timeout
            maximumAge: 60000 // Allow cached for 1 min
          }
        );
      } else {
        console.warn('Geolocation is not supported by this browser/WebView.');
        if (!isIOS) {
          alert('Geolocation is not supported by this browser/WebView.');
        }
        // Use default location instead of rejecting
        const defaultLocation = { latitude: 0, longitude: 0 };
        setLocation(defaultLocation);
        resolve(defaultLocation);
      }
    });
  };

  const handleUpdateStatus = async (status) => {
    try {
      setLoading(true)
      // Removed load() call to prevent potential loops

      let currentGeoLocation;
      try {
        currentGeoLocation = await geolocation();
      } catch (error) {
        // Geolocation failed, alert was shown in geolocation(), setLoading(false) and return.
        setLoading(false);
        return; 
      }
      
      // It's possible geolocation resolved with 0,0 if cached value was 0,0 or other edge cases.
      // Or if the device genuinely reports 0,0 (e.g. middle of ocean, or a simulator default)
      // For practical purposes in an urban app, 0,0 is usually an error indicator.
      if (currentGeoLocation.latitude === 0 && currentGeoLocation.longitude === 0) {
        alert(
          'Could not get a valid location (received 0,0). Please ensure your location is on and try again.',
        );
        setLoading(false);
        return; // Stop execution if location is invalid
      }
      
      let formatStatus = status.replace(' ', '-').toLowerCase()
      // let previous = null; // previous logic seemed unused
      // let dataDate = new Date(currentDate);
      // if (dataDate.getDate() !== today.getDate() || status !== 'time-in') {
      // previous = currentDate;
      // }

      if (basicUser._id === undefined) {
        // load() // Re-calling load() might be too much, consider a more targeted refresh or error
        alert('User data is not loaded. Please try again.');
        setLoading(false);
        return;
      }
      
      const result = await user_api.post_user_status(formatStatus, currentGeoLocation, basicUser._id, report._id)
        if (!result.ok) {
          setLoading(false)
          Bugsnag.notify(result)
         enqueueSnackbar(result.data.msg, {variant: 'error'})
         return {status: 500, error: result.data.msg}
        } else {
          // Check if result.data and result.data.status exist
          if (result.data && typeof result.data.status !== 'undefined') {
            switch (result.data.status) {
              case 'time-in':
                setStatus('Time out')
                break
              case 'time-out':
                setStatus('Time in')
                break
              case 'break-in':
                setStatus('Break out')
                break
              case 'break-out':
                setStatus('Break in')
                break
              default:
                // Optional: Log if status is unexpected but data exists
                console.warn('Unexpected status from API in handleUpdateStatus:', result.data.status);
                break
            }
            if (socket) {
              socket.emit('update_status', status) // 'status' is the function parameter
            } else {
              console.error("Socket is not available for emitting status update in handleUpdateStatus.");
              Bugsnag.notify(new Error("Socket is not available in handleUpdateStatus"));
              enqueueSnackbar('Connection issue: Could not update status.', {variant: 'warning'});
            }
            enqueueSnackbar(`${status} Success`, {variant: 'success'})
            setLoading(false)
            handleStatus(basicUser._id)
            return {status: 200}
          } else {
            // Handle case where result.data or result.data.status is missing
            setLoading(false)
            const errorMsg = 'API response missing or has invalid status after status update.';
            Bugsnag.notify(new Error(errorMsg), (event) => {
              event.addMetadata('apiResponse', { result });
            });
            enqueueSnackbar(errorMsg, {variant: 'error'});
            return {status: 500, error: errorMsg};
          }
        }
      } catch (error) {
        console.error("Error in handleUpdateStatus: ", error);
        setLoading(false);
        Bugsnag.notify(error);
        enqueueSnackbar('An unexpected error occurred while updating status.', {variant: 'error'});
        return {status: 500, error: 'Unexpected error in handleUpdateStatus: ' + error.message};
      }
  }

  const handleUpdateWorkmateStatus = async (status) => {
    try {
      setLoading(true)
      // if (!status) return setLoading(false) // Status is always passed

      let currentGeoLocation;
      try {
        currentGeoLocation = await geolocation();
      } catch (error) {
        setLoading(false);
        // error already alerted in geolocation
        return {status: 500, error: 'Geolocation failed in handleUpdateWorkmateStatus'};
      }

      if (currentGeoLocation.latitude === 0 && currentGeoLocation.longitude === 0) {
        alert(
          'Could not get a valid location (received 0,0) for workmate. Please ensure location is on and try again.',
        );
        setLoading(false);
        return {status: 500, error: 'Invalid location (0,0) for workmate'};
      }
      
      let formatStatus = status.replace(' ', '-').toLowerCase()
      // let previous = null; // previous logic seemed unused
      // let dataDate = new Date(currentDate);
      // if (dataDate.getDate() !== today.getDate() || status !== 'time-in') {
      // previous = currentDate;
      // }
      let workmate = user.displayName // This `user` state might need to be `basicUser` or ensured it's the correct one
      let processDate = workmateReport._id

      if (!value || !processDate) {
         alert('Workmate data or report ID is missing. Please try again.');
         setLoading(false);
         return {status: 400, error: 'Workmate data or report ID missing'};
      }

      const result = await user_api.post_user_workmate_status(formatStatus, currentGeoLocation, value, processDate, workmate)
      if (!result.ok) {
        setLoading(false)
        Bugsnag.notify(result)
        enqueueSnackbar(result.data.msg, {variant: 'error'});
        return {status: 500, error: result.data.msg || 'Failed to update workmate status'};
      }

      // Check if result.data and result.data.status exist
      if (result.data && typeof result.data.status !== 'undefined') {
        switch (result.data.status) {
          case 'time-in':
            setWorkmateStatus('Time out')
            break
          case 'time-out':
            setWorkmateStatus('Time in')
            break
          case 'break-in':
            setWorkmateStatus('Break out')
            break
          case 'break-out':
            setWorkmateStatus('Break in')
            break
          default:
            console.warn('Unexpected workmate status from API in handleUpdateWorkmateStatus:', result.data.status);
            break
        }

        if (socket) {
          socket.emit('update_status', status); // 'status' is the function parameter
        } else {
          console.error("Socket is not available for emitting status update in handleUpdateWorkmateStatus.");
          Bugsnag.notify(new Error("Socket is not available in handleUpdateWorkmateStatus"));
          enqueueSnackbar('Connection issue: Could not update workmate status.', {variant: 'warning'});
        }
        enqueueSnackbar(`${status} Success`, {variant: 'success'})
        setLoading(false)
        handleWorkmateStatus(value)
        return {status: 200}
      } else {
        setLoading(false)
        const errorMsg = 'Workmate API response missing or has invalid status after status update.';
        Bugsnag.notify(new Error(errorMsg), (event) => {
          event.addMetadata('apiResponse', { result });
        });
        enqueueSnackbar(errorMsg, {variant: 'error'});
        return {status: 500, error: errorMsg};
      }
    } catch (error) {
      console.error("Error in handleUpdateWorkmateStatus: ", error);
      setLoading(false);
      Bugsnag.notify(error);
      enqueueSnackbar('An unexpected error occurred while updating workmate status.', {variant: 'error'});
      return {status: 500, error: 'Unexpected error in handleUpdateWorkmateStatus: ' + error.message};
    }
  }

  const handleWorkmateStatus = async (_id) => {
    if (!_id) {
      setLoading(false)
      return navigate('/login')
    }
    setLoading(true)
    const result = await user_api.get_user_status(_id)
    if (!result.ok) {
      setLoading(false)
      Bugsnag.notify(result)
      setWorkmateStatus(null)
    }

    if (!result || !result.data) {
      setWorkmateStatus(null)
      return setLoading(false)
    }
    let {status, date} = result.data[0] // get the last data
    let record_date = new Date(date)
    setWorkmateStatus(status)
    setCurrentDate(date)
    setWorkmateReport(result.data[0])
    if (record_date.getDate() !== today.getDate() && status === 'time-out') {
      setWorkmateStatus(null)
      setLoading(false)
      return
    }
    switch (status) {
      case 'time-in':
        setWorkmateStatus('Time in')
        break
      case 'time-out':
        setWorkmateStatus('Time out')
        break
      case 'break-in':
        setWorkmateStatus('Break in')
        break
      case 'break-out':
        setWorkmateStatus('Break out')
        break
      default:
        break
    }
    setLoading(false)
  }

  const handleRestartTour = async () => {
      console.log("restart tour", userData)
      if (!userData.email === 'sparkletimekeepingdemo+01@gmail.com') return navigate('/login')
        setLoading(true)
      const result = await user_api.delete_demo_last_record(userData._id)
      if (!result.ok) {
        setLoading(false)
        return
      }
      window.location.reload()
  }

  const handleStatus = async (_id) => {
    if (!_id) {
      return navigate('/login')
    }
    setLoading(true)
    const result = await user_api.get_user_status(_id)

    if (!result.ok) {
      setStatus(null)
      setLoading(false)
    }
    if (!result || !result.data) {
      setStatus(null)
      setLoading(false)
    }

    /*    if (!result.data) return setLoading(false)*/
    let {status, date} = result.data[0] // get the last data

    let record_date = new Date(date)

    // if (record_date.getDate() === today.getDate() && record_date.getUTCMonth() + 1 === today.getUTCMonth() + 1) {
    // Removed setStatus(status) here to prevent setting raw API status
    setCurrentDate(date)
    setReport(result.data[0])
    // } else {
    if (record_date.getDate() !== today.getDate() && status === 'time-out') {
      setStatus(null)
    }
    // }

    // Check if user has timed out
    if (status === 'time-out') {
      setUserTimedOut(true)
    } else {
      setUserTimedOut(false)
    }

    switch (status) {
      case 'time-in':
        setStatus('Time in')
        break
      case 'time-out':
        setStatus('Time out')
        break
      case 'break-in':
        setStatus('Break in')
        break
      case 'break-out':
        setStatus('Break out')
        break
      default:
        setStatus(null)
        break
    }
    setLoading(false)
  }
  const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
  })

  const ButtonMemo = React.memo(ButtonContainerMemo)
  const WorkmateButtonMemo = React.memo(WorkmateButtonContainerMemo)

  function ButtonContainerMemo() {
    return <RenderButtonStatus />
  }

  function WorkmateButtonContainerMemo() {
    return <WorkmateRenderButtonStatus />
  }

  const handleSwitchTimeBreak = (statement) => {
    if (statement === true && status === 'Time in') {
      setStatus('Break out')
      RenderButtonStatus()
    } else if (statement === false && status === 'Break in') {
      setStatus('Time in')
      RenderButtonStatus()
    } else if (statement === false && status === 'Break out') {
      setStatus('Time in')
      RenderButtonStatus()
    }
  }

  const RenderButtonStatus = () => {
    const cur_status = status

    //const cur_status = 'Break in'
    switch (cur_status) {
      case null:
        return (
          <>
            {/* <Box>
                  {previousLocation && (
                  <iframe 
                      title="resumeIframe"
                      src={`https://maps.google.de/maps?hl=en&q=${location.latitude},${location.longitude}&ie=UTF8&t=&z=17&iwloc=B&output=embed`}                            
                      width="100%" 
                      height="280" 
                      frameBorder="0"
                      scrolling="no"
                      marginHeight="0"
                      marginWidth="0"
                      allowfullscreen=""
                      key={`landmark-${location.latitude}`} 
                      >
                  </iframe>
                  )}
                  <h4 style={{"margin-left": '80px'}}>Current Location</h4>
                </Box> */}

            <Grid container direction={'column'} gap={3} justifyContent="center" alignItems={'center'} sx={{ mt: '3px', ml: .1 }}>
              <Grid container direction={'row'} gap={3} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}> 
                <Grid width={'fit-content'} item>
                  <TimeIn request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
                <Grid width={'fit-content'} item>
                  <TimeOut request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
              </Grid>
              <Grid container direction={'row'} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}>
                <Grid width={'fit-content'} item>
                  <BreakSwitch current_status={cur_status} handleSwitchTimeBreak={handleSwitchTimeBreak} disabled={true} greyDisabled={true} />
                </Grid>
              </Grid>
              {userData.email === 'sparkletimekeepingdemo+01@gmail.com' && (
                <Grid 
                  container 
                  direction="row" 
                  justifyContent="center" 
                  alignItems="center" 
                  sx={{ width: "100%", mt: 2 }}
                >
                  <Grid item width="fit-content">
                    <Button
                      id="restartTour"
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        handleRestartTour();
                      }}
                    >
                      Restart Tour
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </>
        )
      case 'Time in':
        return (
          <>
            {/* <Box>
                {previousLocation && (
                <iframe 
                    title="resumeIframe"
                    src={`https://maps.google.de/maps?hl=en&q=${location.latitude},${location.longitude}&ie=UTF8&t=&z=17&iwloc=B&output=embed`}                            
                    width="100%" 
                    height="280" 
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    allowfullscreen=""
                    key={`landmark-${location.latitude}`} 
                    >
                </iframe>
                )}
                <h4 style={{"margin-left": '80px'}}>Current Location</h4>
              </Box> */}
            <Grid container direction={'column'} gap={3} justifyContent="center" alignItems={'center'} sx={{ mt: '3px', ml: .1 }}>
              <Grid container direction={'row'} gap={3} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}>
                <Grid width={'fit-content'} item>
                  <TimeIn request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
                <Grid width={'fit-content'} item>
                  <TimeOut request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
              </Grid>
              <Grid container direction={'row'} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}> 
                <Grid width={'fit-content'} item>
                  <BreakSwitch current_status={cur_status} handleSwitchTimeBreak={handleSwitchTimeBreak} isDemo={userData?.email === 'sparkletimekeepingdemo+01@gmail.com'} />
                </Grid>
                {userData.email === 'sparkletimekeepingdemo+01@gmail.com' && (
                  <Grid 
                    container 
                    direction="row" 
                    justifyContent="center" 
                    alignItems="center" 
                    sx={{ width: "100%", mt: 2 }}
                  >
                    <Grid item width="fit-content">
                      <Button
                        id="restartTour"
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          handleRestartTour();
                        }}
                      >
                        Restart Tour
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
            
          </>
        )
      case 'Break in':
        return (
          <>
            {/* <Box>
                {previousLocation && (
                <iframe 
                    title="resumeIframe"
                    src={`https://maps.google.de/maps?hl=en&q=${location.latitude},${location.longitude}&ie=UTF8&t=&z=17&iwloc=B&output=embed`}                            
                    width="100%" 
                    height="280" 
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    allowfullscreen=""
                    key={`landmark-${location.latitude}`} 
                    >
                </iframe>
                )}
                <h4 style={{"margin-left": '80px'}}>Current Location</h4>
              </Box> */}
            <Grid container direction={'column'} gap={3} justifyContent="center" alignItems={'center'} sx={{ mt: '3px', ml: .1 }}>
              <Grid container direction={'row'} gap={3} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}>
                <Grid width={'fit-content'} item>
                  <BreakIn request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
                <Grid width={'fit-content'} item>
                  <BreakOut request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
              </Grid>
              <Grid container direction={'row'} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}>
                <Grid width={'fit-content'} item>
                  <BreakSwitch current_status={cur_status} handleSwitchTimeBreak={handleSwitchTimeBreak} />
                </Grid>
              </Grid>
            </Grid>
          </>
        )
      case 'Break out':
        return (
          <>
            {/* <Box>
                {previousLocation && (
                <iframe 
                    title="resumeIframe"
                    src={`https://maps.google.de/maps?hl=en&q=${location.latitude},${location.longitude}&ie=UTF8&t=&z=17&iwloc=B&output=embed`}                            
                    width="100%" 
                    height="280" 
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                    allowfullscreen=""
                    key={`landmark-${location.latitude}`} 
                    >
                </iframe>
                )}
                <h4 style={{"margin-left": '80px'}}>Current Location</h4>
              </Box> */}
            <Grid container direction={'column'} gap={3} justifyContent="center" alignItems={'center'} sx={{ mt: '3px', ml: .1 }}>
              <Grid container direction={'row'} gap={3} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}>
                <Grid width={'fit-content'} item>
                  <BreakIn request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
                <Grid width={'fit-content'} item>
                  <BreakOut request={handleOpenTimein} current_status={cur_status} width="300px" location={location} />
                </Grid>
              </Grid>
              <Grid container direction={'row'} justifyContent="center" alignItems={'center'} sx={{ width: '100%' }}>
                <Grid width={'fit-content'} item>
                  <BreakSwitch current_status={cur_status} handleSwitchTimeBreak={handleSwitchTimeBreak} />
                </Grid>
              </Grid>
            </Grid>
          </>
        )
      case 'Time out':
        return (
          <>
            <Completed currentDate={currentDate} />
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '1.5rem'}}>
              <Button
                id='newShift'
                onClick={() => setStatus(null)}
                sx={{
                  marginTop: '1.5rem',
                  borderRadius: 28,
                  backgroundColor: '#1F98E8',
                  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.35)!important',
                  color: 'white!important',
                  width: '150px',
                }}
              >
                New Shift
              </Button>
            </div>
          </>
        )
      default:
        return <Loading />
    }
  }

  const WorkmateRenderButtonStatus = () => {
    const cur_status = workmateStatus

    switch (cur_status) {
      case null:
        return <TimeIn request={handleUpdateWorkmateStatus} width="215px" location={location} />
      case 'Time in':
        return (
          <>
            <TimeOut
              request={handleUpdateWorkmateStatus}
              width="215px"
              current_status={cur_status}
              location={location}
            />
            <BreakIn
              request={handleUpdateWorkmateStatus}
              width="215px"
              current_status={cur_status}
              location={location}
            />
            <span> for {` ${new Date(currentDate).toDateString()} `}</span>
          </>
        )
      case 'Break in':
        return (
          <>
            <BreakOut
              request={handleUpdateWorkmateStatus}
              width="215px"
              current_status={cur_status}
              location={location}
            />
            <TimeOut
              request={handleUpdateWorkmateStatus}
              width="215px"
              current_status={cur_status}
              location={location}
            />
            <span> for {` ${new Date(currentDate).toDateString()} `}</span>
          </>
        )
      case 'Break out':
        return (
          <>
            <TimeOut
              request={handleUpdateWorkmateStatus}
              width="215px"
              current_status={cur_status}
              location={location}
            />
            <BreakIn
              request={handleUpdateWorkmateStatus}
              width="215px"
              current_status={cur_status}
              location={location}
            />
            <span> for {` ${new Date(currentDate).toDateString()} `}</span>
          </>
        )
      case 'Time out':
        return (
          <>
            <Completed currentDate={currentDate} />
            <button onClick={() => setWorkmateStatus(null)}>Ok</button>
          </>
        )
      default:
        return <Loading />
    }
  }

  const handleClose = () => {
    setSelected(false)
  }
  const handleOpenTimein = async (cur_status) => {
    if ((ls.get("confirmStatus") === "" || ls.get("confirmStatus") === "false") && mySchedule && cur_status === "Time in") {
      setConfirmScheduleDialog(true)
    }
    else {
      const location = await geolocation()
      if (location.latitude === 0) {
        geolocation()
        alert('Please turn on location of mobile and browser, refresh then try again')
        setLoading(false)
      } else {
        getVideo("running")
        const data = {
          store: basicUser.company,
        }
        const checklist = await user_api.get_checklist(data)
        if (checklist.data.data !== 'No records found') {
          setChecklistToggle(checklist.data.data[0].toggle)
          setChecklists(checklist.data.data[0].checklists)
        }
        setSuccessStatus(true)
        setDialogStatus(false)
        setCurStatus(cur_status)
        setOpenTimein(true)
        setTimeinStatus(true)
        setCaptureStatus(false)
      }  
      if(userData.email === 'sparkletimekeepingdemo+01@gmail.com' && cur_status === 'Time out') {
        setDemoDialogOpen(true)
      }
    }
    
  }

  const handleCloseTimein = async () => {
    setValidatedChecklist(false)
    setSuccessStatus(true)
    setTimeinStatus(true)
    setDialogStatus(false)
    // setUniformCheckboxChange(false)
    // setNameplateCheckboxChange(false)
    // setGroomingCheckboxChange(false)
    // setVacCheckboxChange(false)
    setAcknowledged(false)
    setOpenTimein(false)
    setCameraRetryCount(0) // Reset retry count
    setCameraInitStarted(false)
    setCameraReady(false)
    getVideo('done')
    load()
    setLoading(false)
  }

  // const checkAll = async (e) => {
  //   setCheckboxChange(e)
  //   setUniformCheckboxChange(e)
  //   setNameplateCheckboxChange(e)
  //   setGroomingCheckboxChange(e)
  //   setVacCheckboxChange(e)
  // }


  const handleCloseOtherStore = async () => {
    setOpenOtherStore(false)
    setOtherStore(false)
  }

  const handleOpenWorkmateTimein = async () => {
    setOpenWorkmateTimein(true)
  }

  const handleCloseWorkmateTimein = () => {
    setValue(null)
    setOpenWorkmateTimein(false)
    setValidated(false)
    setLoading(false)
    setValidatedChecklist(false)
    setScanMessage('No data found')
  }
  const handleScan = async (res) => {
    if (res) {
      const result = await user_api.get_user_status(res)
      if (result.data[0].status === 'time-out') {
        setCurStatus('Time in')
      }
      if (result.data[0].status !== 'time-out' && result.data[0].status === 'time-in') {
        setCurStatus('Time out')
      }
      setValue(res)
      const userResult = await user_api.get_user(res)
      setQrUser(userResult.data)
    }
  }

  const handleAcknowledge = async () => {
    setAcknowledged(true)
    setOpenAcknowledegment(false)
    
    // If this is a schedule confirmation acknowledgment, proceed with the confirmation
    if (isScheduleConfirmation) {
      await handleConfirmSchedule()
    }
  }

  const handleConfirmScheduleScan = async (res) => {
    if (res) {
      //  const parts = res.split("/");
      //  const id = parts[parts.length - 2]
      //  const result = await user_api.get_store(id)
       const id = res
       const result = await user_api.get_store_qr(id)
      if(result.data.company === basicUser.company) {
        setLoading(true)
        let totalHours = 0
        let totalHours2 = 0
        if (typeof (from) !== "string" || typeof (to) !== "string") {
          alert("Please choose start shift and end shift")
          setLoading(false)
        }
        else if (!position) {
          alert("Please choose position")
          setLoading(false)
        }
        else {
          if (typeof (from) === "string" || typeof (to) === "string") {
            const startDate = new Date(`2023-03-15T${from}`);
            const endDate = new Date(`2023-03-15T${to}`);

            const diffInMilliseconds = endDate - startDate;
            const diffInSeconds = diffInMilliseconds / 1000;
            const diffInMinutes = diffInSeconds / 60;
            const diffInHours = diffInMinutes / 60;
            const hours = breakMin / 60;
            totalHours = getTimeDifferenceSchedule(from, to)
            totalHours2 = totalHours.hours + (totalHours.minutes / 60) - hours;
          }
          
          if (isEditingExistingSchedule && specificSchedule) {
            // Update existing schedule using post_schedule_employee
            let scheduleDate;
            if (currentRecord && currentRecord.record && Object.keys(currentRecord).length > 0) {
              if (isFutureSchedule) {
                // Editing a future schedule, use its date
                scheduleDate = moment(specificSchedule.date).format('L');
              } else {
                // User has a record for today AND has completed their shift, create for tomorrow
                scheduleDate = moment().add(1, 'day').format('L');
              }

            }
             else {
              // No record for today OR user hasn't completed their shift, edit today's schedule
              scheduleDate = moment().format('L');
            }
            
            const updateData = {
              uid: basicUser._id,
              date: scheduleDate,
              from: from,
              to: to,
              totalHours: totalHours2,
              breakMin: breakMin,
              position: position,
              ot: specificSchedule.ot || 0,
              nightdiff: specificSchedule.nightdiff || 0,
              rd: specificSchedule.rd || 0
            }
            
            try {
              const response = await user_api.post_schedule(updateData)
              if (response.status === 200) {
                alert("Schedule updated successfully")
                setSaveScheduleSuccess(false)
                setOpenCreateScheduleDialog(false)
                setIsEditingExistingSchedule(false)
                setLoading(false)
              } else if (response.status === 400 && response.data && response.data.breaklistExists) {
                // Handle breaklist validation error
                alert(response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
                setSaveScheduleSuccess(false)
                setOpenCreateScheduleDialog(false)
                setLoading(false)
              } else {
                alert("Something went wrong please try again later")
                setLoading(false)
              }
            } catch (error) {
              console.error('Error updating schedule:', error);
              if (error.response && error.response.status === 400 && error.response.data && error.response.data.breaklistExists) {
                alert(error.response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
              } else {
                alert("Something went wrong please try again later")
              }
              setSaveScheduleSuccess(false)
              setOpenCreateScheduleDialog(false)
              setLoading(false)
            }
          } else {
            // Create new schedule using post_schedule
            const now = new Date();
            const data = {
              uid: basicUser._id,
              name: basicUser.displayName,
              company: basicUser.company,
              date: moment(addDays(now, 0)).format('L'),
              from: from,
              to: to,
              totalHours: totalHours2,
              breakMin: breakMin,
              position: position,
              ot: 0,
              nightdiff: 0,
              rd: 0
            }
            try {
              const response = await user_api.post_schedule(data)
              if (response.status === 200) {
                  /*ls.set("schedStatus", "true")*/
                  alert("Schedule created successfully")
                  setSaveScheduleSuccess(false)
                  setOpenCreateScheduleDialog(false)
                  setLoading(false)
              } else if (response.status === 400 && response.data && response.data.breaklistExists) {
                // Handle breaklist validation error
                alert(response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
                setSaveScheduleSuccess(false)
                setOpenCreateScheduleDialog(false)
                setLoading(false)
              } else {
                alert("Something went wrong please try again later")
                setLoading(false)
              }
            } catch (error) {
              console.error('Error creating schedule:', error);
              if (error.response && error.response.status === 400 && error.response.data && error.response.data.breaklistExists) {
                alert(error.response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
              } else {
                alert("Something went wrong please try again later")
              }
              setSaveScheduleSuccess(false)
              setOpenCreateScheduleDialog(false)
              setLoading(false)
            }
          }
        }
        window.location.reload()  
      }
    }
  }

  const handleError = (err) => {
    console.error(err)
  }

  function handleCheckboxChange(e) {
    setValidated(e.target.checked)
  }

  const handleCheckboxChangeStore = (event) => {
    setOtherStore(event.target.checked)
  }

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById('qr-gen')
    const pngUrl = canvas.toDataURL('image/png')
    let downloadLink = document.createElement('a')
    downloadLink.href = pngUrl

    // Check if running in a React Native WebView environment
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      // Send the image data to the React Native app
      window.ReactNativeWebView.postMessage(pngUrl)
    }
    downloadLink.download = `${name}.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  const handleGenerateQR = (e) => {
    setId(basicUser._id)
    setName(basicUser.displayName)
    setOpenQR(true)
  }

  const handleOpenStore = (e) => {
    setOpenOtherStore(true)
  }
  const handleCloseQR = () => setOpenQR(false)

  const stopStream = (stream) => {
    stream.getTracks().forEach((track) => {
      if (track.readyState === 'live') {
        track.stop()
      }
    })
  }

  const getVideo = async (status) => {
    try {
      if (status === 'running') {
        setCameraInitStarted(true)
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "user", // Use front camera
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
        })
        streamRef.current = stream // Store the stream in a ref
        if (videoRef.current) {
          videoRef.current.srcObject = stream
          videoRef.current.play()
          videoRef.current.style.transform = 'scaleX(-1)';
        }
      } else if (status === 'done') {
        if (streamRef.current) {
          stopStream(streamRef.current)
          streamRef.current = null
        }
        setCameraInitStarted(false)
        setCameraReady(false)
      }
    } catch (err) {
      console.error('Error accessing camera:', err)
      setCameraInitStarted(false)
      setCameraReady(false)

      // Show user-friendly error messages
      if (err.name === 'NotAllowedError') {
        alert('Camera permission denied. Please allow camera access to take photos.');
      } else if (err.name === 'NotFoundError') {
        alert('No camera found. Please check your camera connection.');
      } else if (err.name === 'NotReadableError') {
        alert('Camera is being used by another application. Please close other apps using the camera.');
      } else {
        alert('Unable to access camera. Please check your camera settings.');
      }
    }
  }

  const retryCameraSetup = async () => {
    try {
      // Stop any existing stream
      if (streamRef.current) {
        stopStream(streamRef.current);
        streamRef.current = null;
      }

      setCameraReady(false)

      // Request camera permission again
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "user", // Use front camera
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        }
      });

      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;

        // Wait for video to be ready
        await new Promise((resolve) => {
          videoRef.current.onloadedmetadata = () => {
            videoRef.current.play();
            videoRef.current.style.transform = 'scaleX(-1)';
            resolve();
          };
        });

        // Give the camera a moment to stabilize
        await new Promise(resolve => setTimeout(resolve, 1000));

      } else {
        throw new Error('Video element not available');
      }
    } catch (error) {
      console.error('Camera retry failed:', error);

      // Increment retry count
      setCameraRetryCount(prev => prev + 1);

      // Check if we've exceeded maximum retry attempts (3 attempts)
      if (cameraRetryCount >= 2) {
        // Show user-friendly error message and stop retrying
        if (error.name === 'NotAllowedError') {
          alert('Camera permission denied. Please allow camera access and try again.');
        } else if (error.name === 'NotFoundError') {
          alert('No camera found. Please check your camera connection.');
        } else if (error.name === 'NotReadableError') {
          alert('Camera is being used by another application. Please close other apps using the camera.');
        } else {
          alert('Camera setup failed after multiple attempts. Please check your camera settings and try again.');
        }

        // Reset states and stop the process
        setWaitingForCamera(false);
        setCameraReady(false);
        setCameraInitStarted(false);
        setValidatedChecklist(false);
        setAcknowledged(false);
        setOpenTimein(false);
        getVideo('done');
        setLoading(false);
        setCameraRetryCount(0); // Reset counter
        return;
      }

      // If we haven't exceeded max retries, show warning and retry
      if (error.name === 'NotAllowedError') {
        alert('Camera permission denied. Retrying...');
      } else if (error.name === 'NotFoundError') {
        alert('No camera found. Retrying...');
      } else if (error.name === 'NotReadableError') {
        alert('Camera is being used by another application. Retrying...');
      } else {
        alert('Camera setup failed. Retrying...');
      }

      // Retry after a delay
      setTimeout(() => retryCameraSetup(), 2000);
    }
  }

  const takePicture = async () => {
    // Reset retry count when takePicture is called
    setCameraRetryCount(0);

    let currentGeoLocation;
    try {
      currentGeoLocation = await geolocation();
    } catch (error) {
      // Error already handled by geolocation function (alert)
      setValidatedChecklist(false);
      setAcknowledged(false);
      setOpenTimein(false);
      getVideo('done'); // Stop video stream if it was started
      setLoading(false);
      return;
    }

    if (currentGeoLocation.latitude === 0 && currentGeoLocation.longitude === 0) {
      alert('Could not get a valid location (received 0,0) for picture. Please turn on location and try again.');
      setValidatedChecklist(false);
      setAcknowledged(false);
      setOpenTimein(false);
      getVideo('done');
      setLoading(false);
      return;
    }

    // Check if video is receiving input
    const video = videoRef.current;
    if (!video || !video.srcObject) {
      console.warn('Video stream not available, retrying...');
      if (cameraRetryCount < 3) {
        await retryCameraSetup();
      } else {
        alert('Unable to access camera after multiple attempts. Please check your camera settings and try again.');
        // Reset all camera-related states
        setWaitingForCamera(false);
        setCameraReady(false);
        setCameraInitStarted(false);
        setValidatedChecklist(false);
        setAcknowledged(false);
        setOpenTimein(false);
        getVideo('done');
        setLoading(false);
        setCameraRetryCount(0);
      }
      return;
    }

    // Check if video dimensions are valid (indicates camera input)
    if (video.videoWidth === 0 || video.videoHeight === 0) {
      console.warn('No camera input detected, retrying...');
      if (cameraRetryCount < 3) {
        await retryCameraSetup();
      } else {
        alert('No camera input detected after multiple attempts. Please check your camera and try again.');
        // Reset all camera-related states
        setWaitingForCamera(false);
        setCameraReady(false);
        setCameraInitStarted(false);
        setValidatedChecklist(false);
        setAcknowledged(false);
        setOpenTimein(false);
        getVideo('done');
        setLoading(false);
        setCameraRetryCount(0);
      }
      return;
    }

    // Check if video is actually playing
    if (video.paused || video.ended) {
      console.warn('Video not playing, retrying...');
      if (cameraRetryCount < 3) {
        await retryCameraSetup();
      } else {
        alert('Camera not responding after multiple attempts. Please check your camera settings and try again.');
        // Reset all camera-related states
        setWaitingForCamera(false);
        setCameraReady(false);
        setCameraInitStarted(false);
        setValidatedChecklist(false);
        setAcknowledged(false);
        setOpenTimein(false);
        getVideo('done');
        setLoading(false);
        setCameraRetryCount(0);
      }
      return;
    }

    // Removed setLocation call as geolocation() already updates state and returns the value.
    // We will use currentGeoLocation directly for drawing.

    const width = 1000;
    const height = width / (9 / 9);
    let photo = photoRef.current;
    photo.width = width;
    photo.height = height;
    let ctx = photo.getContext('2d');

    // Flip the canvas context horizontally before drawing the image
    ctx.save();
    ctx.scale(-1, 1);  // Horizontal flip
    ctx.drawImage(video, -width, 0, width, height); // Draw flipped image
    ctx.restore();

    ctx.font = '800 30px Veranda';
    ctx.globalAlpha = 0.7;
    ctx.fillRect(0, 0, 600, 400);
    ctx.fillStyle = 'white';
    ctx.fillText(curStatus, 50, 75);
    if (openWorkmateTimein) {
      ctx.fillText(qrUser.displayName, 50, 135);
    } else {
      ctx.fillText(basicUser.displayName, 50, 135);
    }
    ctx.fillText(moment().format('YYYY-MM-DD HH:mm:ss'), 50, 195); // More precise timestamp
    ctx.fillText('longitude: ' + currentGeoLocation.longitude.toFixed(6), 50, 255); // Use fetched location
    ctx.fillText('latitude: ' + currentGeoLocation.latitude.toFixed(6), 50, 325); // Use fetched location
    // setVacCheckboxChange(false);
    // setGroomingCheckboxChange(false);
    // setNameplateCheckboxChange(false);
    // setUniformCheckboxChange(false);
    // setCheckboxChange(false);
    setAcknowledged(false)
    // Don't stop the video stream immediately after capture - wait until user confirms or cancels
    // getVideo('done'); // Moved this to handleTimein and clearImage functions
    setCaptureStatus(true);
    setTimeinStatus(false);
  };

  const clearImage = () => {
    let photo = photoRef.current
    let ctx = photo.getContext('2d')
    ctx.clearRect(0, 0, photo.width, photo.height)
    setCaptureStatus(false)
    setTimeinStatus(true)
    getVideo('running')
  }

  const handleTimein = async () => {
    setLoading(true)
    // Stop the video stream now that user confirmed the photo
    getVideo('done')
    setTimeinStatus(true)
    setDialogStatus(true)

    if (openWorkmateTimein) {
      const result = await handleUpdateWorkmateStatus(curStatus)
      if (result.status === 200) {
        setSuccessStatus(false)
        const canvas = document.getElementById('canvas')
        const pngUrl = canvas.toDataURL('image/png')
        let downloadLink = document.createElement('a')
        downloadLink.href = pngUrl

        // Check if running in a React Native WebView environment
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          // Send the image data to the React Native app
          window.ReactNativeWebView.postMessage(pngUrl)
        }
        downloadLink.download = `${curStatus} - ${moment().format('LL')}.png`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setTimeout(function () {
          setOpenWorkmateTimein(false)
          setLoading(false)
        }, 5000)
      }
    } else {
      const result = await handleUpdateStatus(curStatus) 

      if (result.status === 200) {
        setSuccessStatus(false)
        const canvas = document.getElementById('canvas')
        const pngUrl = canvas.toDataURL('image/png')
        let downloadLink = document.createElement('a')
        downloadLink.href = pngUrl

        // Check if running in a React Native WebView environment
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          // Send the image data to the React Native app
          window.ReactNativeWebView.postMessage(pngUrl)
        }
        downloadLink.download = `${curStatus} - ${moment().format('LL')}.png`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setTimeout(function () {
          load()
          setOpenTimein(false)
          setLoading(false)
        }, 5000)
      }
    }
    // if(curStatus === "Time out") {
    //   ls.set("confirmStatus", "false")
    //   ls.set("storageUser", basicUser._id)
    // }
    window.location.reload()
  }

  const handleOpenBanner = async () => {
    setLoadingBanner(true)
    setInitialBanner('')
    // const getUser = await storage.getUser()
    // const user = JSON.parse(getUser)
    // const d = {
    //   store: user.company
    // }
    // const getBroadcast = await user_api.get_store_announcement(d)
    // if (getBroadcast.data.data.length > 0) {
    //   setBroadcast(getBroadcast.data.data)
    //   setSelectedBanner(true)
    //   setLoadingBanner(false)
    // }else{
    //   const version = await user_api.get_storyblok_version()
    //   const bannerRequest = await user_api.get_storyblok_banners(version)
    //   setBanners(bannerRequest.data.story.content.slide)
    //   setSelectedBanner(true)
    //   setLoadingBanner(false)
    // }
    const announcement = localStorage.getItem('announceUrl')
    if (announcement) {
      const parsedAnnouncement = JSON.parse(announcement)
      // Filter out announcements with toggle: false before setting broadcast state
      const activeAnnouncements = parsedAnnouncement.filter(ann => ann.toggle !== false)
      setBroadcast(activeAnnouncements)
      setSelectedBanner(true)
      setLoadingBanner(false)
    } else {
      const story = localStorage.getItem('storyUrl')
      setBanners(JSON.parse(story))
      setSelectedBanner(true)
      setLoadingBanner(false)
    }
  }
  const handleCloseBanner = () => {
    const announcement = localStorage.getItem('announceUrl')
    if (announcement) {
      const parsedAnnouncement = JSON.parse(announcement)
      // Filter out announcements with toggle: false
      const activeAnnouncements = parsedAnnouncement.filter(ann => ann.toggle !== false)
      if (activeAnnouncements.length > 0) {
        // Find the minimum rank value among all announcements
        const minRank = Math.min(...activeAnnouncements.map(a => a.rank ?? Infinity))
        // Get all announcements with the minimum rank
        const lowestRanked = activeAnnouncements.filter(a => (a.rank ?? Infinity) === minRank)
        
        if (lowestRanked.length > 0) {
          // Random pick from lowest ranked announcements
          const randomIndex = Math.floor(Math.random() * lowestRanked.length)
          setInitialBanner(lowestRanked[randomIndex])
        } else {
          // Fallback to random if no ranked announcements
          const randomIndex = Math.floor(Math.random() * activeAnnouncements.length)
          setInitialBanner(activeAnnouncements[randomIndex])
        }
      }
      setSelectedBanner(false)
    } else {
      const story = localStorage.getItem('storyUrl')
      if (story) {
        const parsedStory = JSON.parse(story)
        const activeStories = parsedStory.filter(story => story.toggle !== false)
        if (activeStories.length > 0) {
          // Find the minimum rank value among all stories
          const minRank = Math.min(...activeStories.map(s => s.rank ?? Infinity))
          // Get all stories with the minimum rank
          const lowestRanked = activeStories.filter(s => (s.rank ?? Infinity) === minRank)
          
          if (lowestRanked.length > 0) {
            // Random pick from lowest ranked stories
            const randomIndex = Math.floor(Math.random() * lowestRanked.length)
            setInitialBanner(lowestRanked[randomIndex])
          } else {
            // Fallback to random if no ranked stories
            const randomIndex = Math.floor(Math.random() * activeStories.length)
            setInitialBanner(activeStories[randomIndex])
          }
        }
      }
      setSelectedBanner(false)
    }
  }

  const MINUTE_MS = 15000

  const handleClickCurrentShift = () => {
    if (currentRecord) {
      const formattedDate = moment(currentRecord.date).format('ddd MMM DD')
      setCurrentRecordDate(formattedDate)
      setCurrentShift(true)
    } else {
      setCurrentShift(false)
      alert('Data is being loaded please wait')
    }
  }

  const handleCurrentShiftClose = () => {
    setCurrentShift(false)
  }

  const handleConfirmScheduleExtend = () => {
    // Check if it's too early to confirm
    if (isTimeBeforeScheduleStart()) {
      setTooEarlyDialogOpen(true);
      return;
    }

    setIsScheduleConfirmation(true) // Mark this as a schedule confirmation
    setOpenAcknowledegment(true)
  }

  const handleConfirmSchedule = async () => {
    // Check if user has timed out before allowing confirmation
    if (!userTimedOut) {
      alert("You need to time out first before confirming your schedule.")
      return
    }
    
    try {
      if (specificSchedule) {
        setLoading(true)
        
        // Format the date properly for the API
        let scheduleDate = specificSchedule.date
        if (isFutureSchedule && scheduleDate) {
          // Already have the date from the specificSchedule
          scheduleDate = moment(scheduleDate).format('L')
        } else {
          // Use today's date
          scheduleDate = moment().format('L')
        }
        
        // Prepare the update data - include only necessary fields
        const updateData = {
          uid: basicUser._id,
          date: scheduleDate,
          confirmed: true,
          // Include required fields even if not changing them
          ot: specificSchedule.otHours || 0, 
          nightdiff: specificSchedule.nightdiff || 0
        }
        
        // Call the API to update the schedule
        const response = await user_api.post_schedule_employee(updateData)
        if(response.status === 200) {
          // Update local state
          setSpecificSchedule({...specificSchedule, confirmed: true})
          ls.set("confirmStatus", "true")
          
          // Show the confirmation dialog
          setConfirmSchedule(true)
          setNoScheduleDialog(false)
          setOpenConfirmScheduleDialog(true)
          
          // No need to fetch the schedule again, we already have it and know it's confirmed
          
          // Check if we need to find the next schedule
          if (userTimedOut) {
            // Get the next schedule efficiently (we already know user is timed out)
            findAndSetNextSchedule(basicUser._id)
          }
        } else {
          throw new Error("Failed to confirm schedule")
        }
        
        setLoading(false)
      } else {
        setNoScheduleDialog(true)
      }
    } catch (error) {
      setLoading(false)
      console.error('Error confirming schedule:', error)
      alert('Failed to confirm schedule. Please try again.')
    }
  }
  
  // Helper function to find and set the next available schedule
  const findAndSetNextSchedule = async (userId) => {
    try {
      // Only fetch the next schedule when needed
      const nextSchedule = await fetchNextAvailableSchedule(userId)
      
      // If no schedule or same as current, no need to update UI
      if (!nextSchedule || (specificSchedule && nextSchedule._id === specificSchedule._id)) {
        return
      }
      
      // Found a different schedule, switch to it
      setSpecificSchedule(nextSchedule)
      setBreakMinSpecific(nextSchedule.breakMin)
      
      // Check if it's for a future date
      const nextDate = moment(nextSchedule.date).format('YYYY-MM-DD')
      const today = moment().format('YYYY-MM-DD')
      
      // Update UI for date display
      if (nextDate !== today) {
        setIsFutureSchedule(true)
        setScheduleDate(nextDate)
      } else {
        setIsFutureSchedule(false)
      }
      
      // Recalculate total hours with the new schedule
      const totalHrs = await calculateTotalHours(
        {_id: userId}, 
        nextSchedule, 
        true, // User is timed in (since this is called post-confirming a schedule)
        nextSchedule.confirmed || false
      )
      setTotalHours(parseFloat(totalHrs).toFixed(2))
      
      // Set confirmation status for UI
      ls.set("confirmStatus", nextSchedule.confirmed ? "true" : "false")
    } catch (error) {
      console.error('Error finding next schedule:', error)
    }
  }

  const handleConfirmPremiumScan = async (res) => {
    if (res) { 
      // const parts = res.split("/");
      // const id = parts[parts.length - 2]
      // const result = await user_api.get_store(id)
      const id = res
      const result = await user_api.get_store_qr(id)
      if(result.data.company === basicUser.company) {
        const formattedDate = convertDate(selectedDate) 
        const data = {
          "id": basicUser._id,
          "date": formattedDate
        }
        const getSchedule = await user_api.get_specific_schedule_with_date_v2(data)
        if (getSchedule && getSchedule.data && getSchedule.data.length > 0) {
          const data2 = {
            uid: basicUser._id,
            date: moment(addDays(new Date(selectedDate), 0)).format('L'),
            ot: ot,
            nightdiff: nsd,
          }
          const response = await user_api.post_schedule_employee(data2)
          if(response.status === 200) {
            alert("Premium values save!")
            setSavePremiumDialog(false)
            setOpenSetOTDialog(false)
            window.location.reload()
          }
        }
        else {
          alert("Set schedule for this date first!")
        }  
      }
    }
      
    
  }

  const convertDate = (inputDate) => {
    if (!inputDate) return null;
    
    const date = new Date(inputDate); // Convert string to Date object
    return date.toISOString(); // Returns "YYYY-MM-DDTHH:mm:ss.sssZ"
  };

  const handleSaveOT = async () => {
    if(!selectedDate) {
      alert("Please input date!")
    }
    else if(ot === 0 && nsd === 0) {
      alert("No changes have been made!")
    }
    else {
      setSavePremiumDialog(true)
    } 
  }
  /* useEffect(() => {
     if (selectedBanner) {
       const interval = setInterval(async () => {
         const getUser = await storage.getUser()
         const user = JSON.parse(getUser)
         const d = {
           store: user.company
         }
         const getBroadcast = await user_api.get_store_announcement(d)
         if (getBroadcast.data !== null) {
           setBroadcast(getBroadcast.data.data)
         }
 
       }, MINUTE_MS);
 
       return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
     }
   }, [selectedBanner])*/
  /*  useEffect(() => {

    const interval = setInterval(() => {

      if (!navigator.onLine) {
        alert('You are offline. Please check your internet connection.');
      }

    }, 1000);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [])
*/

  useEffect(() => {
    // const initializeDemo = async () => {
    //   if (status === 'Time out') {
    //     if (!userData.email === 'sparkletimekeepingdemo+01@gmail.com') return navigate('/login')
    //       setLoading(true)
    //     const result = await user_api.delete_demo_last_record(userData._id)
    //     if (!result.ok) {
    //       setLoading(false)
    //       return
    //     }
    //   }
    // }

    // initializeDemo()
    const fetchData = async () => {
      try {
        const getUser = await storage.getUser()
        const user = JSON.parse(getUser)
        const d = {store: user.company}
        setUserData(user)

        // Fetch recent records alongside other data
        fetchRecentRecords(user._id);

        const getBroadcast = await user_api.get_store_announcement(d)
        const announcements = getBroadcast.data.data.filter(ann => ann.toggle !== false)
        if (announcements.length > 0) {
          // Find the minimum rank value among all announcements
          const minRank = Math.min(...announcements.map(a => a.rank ?? Infinity))
          // Get all announcements with the minimum rank
          const lowestRanked = announcements.filter(a => (a.rank ?? Infinity) === minRank)
          
          if (lowestRanked.length > 0) {
            // Random pick from lowest ranked announcements
            const randomIndex = Math.floor(Math.random() * lowestRanked.length)
            setInitialBanner(lowestRanked[randomIndex]);
          }
          else {
            // Fallback to random if no ranked announcements
            const randomNum = Math.floor(Math.random() * announcements.length)
            setInitialBanner(announcements[randomNum])
          }
          localStorage.setItem('announceUrl', JSON.stringify(announcements))
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoadingBanner(false)
      }
    }

    const fetchSchedule = async () => {
      try {
        // Get user data from storage
        const getUser = await storage.getUser()
        const user = JSON.parse(getUser)
        
        // Make parallel API calls to fetch all required data at once
        const [userDataResult, featureData] = await Promise.all([
          user_api.get_limited_users(user._id),
          user_api.get_features({ store: user.company })
        ])
        
        // Extract user's time records
        const userData = userDataResult.data[0]
        const timeIn = filterByStatus(userData.record, 'time-in').time
        const timeOut = filterByStatus(userData.record, 'time-out').time
        const hasTimedIn = timeIn !== "n/a"
        const hasTimedOut = timeOut !== "n/a"
        let hasMySchedule = false
        let hasPremiumValues = false
        let hasCompany = false
        let hasDocuments = false
        // Set the timed out status for UI
        setUserTimedOut(hasTimedOut)
        
        // Process feature data
        if (featureData.data.length > 0) {

          
          featureData.data.forEach(feature => {
            feature.features.forEach(data => {
              if (data.feature === "My Schedule") {
                hasMySchedule = true
              }
              if (data.feature === "Premium Values") {
                hasPremiumValues = true
              }
            })
          })
          
          setMySchedule(hasMySchedule)
          setMyPremiumValues(hasPremiumValues)
        }
        
        // Get next available schedule efficiently using our optimized function
        // Pass the user data we already have to avoid extra API calls
        const nextSchedule = await fetchNextAvailableSchedule(user._id)
        if (nextSchedule) {
          // Set the schedule in state
          setSpecificSchedule(nextSchedule)
          setBreakMinSpecific(nextSchedule.breakMin)
          setCheckSchedule(true)
          
          // Check if it's for a future date
          const scheduleDate = moment(nextSchedule.date).format('YYYY-MM-DD')
          const today = moment().format('YYYY-MM-DD')
          
          if (scheduleDate !== today) {
            setIsFutureSchedule(true)
            setScheduleDate(scheduleDate)
          } else {
            setIsFutureSchedule(false)
          }
          
          // Calculate total hours with the data we already have to avoid duplicate API calls
          const totalHrs = await calculateTotalHours(
            user,
            nextSchedule, 
            hasTimedIn,
            nextSchedule.confirmed || false,
            userData // Pass the user record data we already fetched
          )
          // Set confirmation status for UI
          if (!curStatus || curStatus !== "Time out") {

            setTotalHours(parseFloat(totalHrs).toFixed(2))
            ls.set("confirmStatus", nextSchedule.confirmed ? "true" : "false")
          } else if (nextSchedule.confirmed) {

            setTotalHours(parseFloat(totalHrs).toFixed(2))
            ls.set("confirmStatus", "true")
          } else {
            setTotalHours(parseFloat(totalHrs).toFixed(2))
            ls.set("confirmStatus", "false")
          }
        } else {
          if(hasTimedOut && !hasMySchedule) {
            // Use the userData we already fetched instead of making another API call
            const recordData = {
              timeInRecord: filterByStatus(userData.record, 'time-in').time,
              timeOutRecord: filterByStatus(userData.record, 'time-out').time,
              breakInRecord: filterByStatus(userData.record, 'break-in').time,
              breakOutRecord: filterByStatus(userData.record, 'break-out').time
            };
            let start = moment(recordData.timeInRecord, "h:mm A");
            let end = moment(recordData.timeOutRecord, "h:mm A");
            if (end.isBefore(start)) {
              end.add(1, "day");
            }
            const totalMinutesWorked = end.diff(start, "minutes");
            let actualHoursWorked
            if(recordData.breakInRecord === 'n/a')
            {
              actualHoursWorked = totalMinutesWorked / 60;
            }
            else{
              let breakStart = moment(recordData.breakInRecord, "h:mm A");
              let breakEnd = moment(recordData.breakOutRecord, "h:mm A");
              let actualBreakMinutes = breakEnd.diff(breakStart, "minutes");
              if (breakEnd.isBefore(breakStart)) {
                breakEnd.add(1, "day");
              } 
              actualHoursWorked = (totalMinutesWorked - actualBreakMinutes) / 60;
            }
            setTotalHours(Math.floor(actualHoursWorked)) 
          }
          setCheckSchedule(false)
          setNoUnconfirmedSchedules(true)
          // setTotalHours('0')
          ls.set("confirmStatus", "false")
        }
        
        // Store user ID for later use
        ls.set("storageUser", user._id)
        ls.set("schedStatus", "true")
      } catch (error) {
        console.error('Error fetching schedule:', error)
        setTotalHours('0') // Default to 0 on error
      }
    }
    
    load();
    fetchData()
    fetchSchedule()
    // enable overflow on mount with 2 second delay
    setTimeout(() => {
      document.documentElement.style.overflow = 'auto';
    }, 2000);
  }, [])

  const tourStartedRef = useRef(false);

  // useEffect(() => {
  //   const checkDemo = async () => {
  //     const getUser = await storage.getUser();
  //     const userData = JSON.parse(getUser);

  //     if (
  //       !tourStartedRef.current && // ✅ Prevent multiple runs
  //       status === 'Time out' &&
  //       userData?.email === "sparkletimekeepingdemo+01@gmail.com"
  //     ) {
  //       console.log(userData?.email, "demoemail");

  //       const waitForNewShift = setInterval(() => {
  //         const newShiftBtn = document.querySelector('#newShift');
  //         if (newShiftBtn) {
  //           console.log(userData, "demoemailDAta");

  //           clearInterval(waitForNewShift);
  //           tourStartedRef.current = true; // ✅ Mark as started permanently
  //           newShiftBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

  //           setTimeout(() => {
  //             tourSteps();
  //           }, 300);
  //         }
  //       }, 100);
  //     }
  //   };

  //   checkDemo();
  //    // optional cleanup: clear interval if unmounted before button appears
  //   return () => clearInterval();
  // }, [status]);

  useEffect(() => {
  let waitForNewShift; // store interval ID here

  const checkDemo = async () => {
    const getUser = await storage.getUser();
    const userData = JSON.parse(getUser);

    if (
      !tourStartedRef.current && // ✅ Prevent multiple runs
      status === 'Time out' &&
      userData?.email === "sparkletimekeepingdemo+01@gmail.com"
    ) {
      console.log(userData?.email, "demoemail");

      waitForNewShift = setInterval(() => {
        const newShiftBtn = document.querySelector('#newShift');
        if (newShiftBtn) {
          console.log(userData, "demoemailDAta");

          clearInterval(waitForNewShift); // ✅ stop interval immediately
          tourStartedRef.current = true; // ✅ Mark as started permanently

          newShiftBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

          setTimeout(() => {
            tourSteps();
          }, 300);
        }
      }, 100);
    }
  };

  checkDemo();

  // ✅ Proper cleanup
  return () => {
    if (waitForNewShift) clearInterval(waitForNewShift);
  };
}, [status]);

  // Remove the separate fetchFeature useEffect since we integrated it above
  // useEffect(() => {
  //   const fetchFeature = async () => {
  //     ...
  //   }
  //   fetchFeature()
  // }, [])

  const convertToAmPm = (time) => {
    // Check if the input time is the string "N/A"
    if (time === "N/A") {
      return "N/A";
    }

    let [hours, minutes] = time.split(":").map(Number);
    let period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0H to 12 AM, and 12H stays 12 PM
    return `${hours}:${minutes.toString().padStart(2, "0")} ${period}`;
  }

  const formatDate = (inputDate) => {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const [year, month, day] = inputDate.split("-");
      return `${months[Number(month) - 1]} ${Number(day)}, ${year}`;
  }
  async function getTimeDifference() {
    const getUser = await storage.getUser()
    const user = JSON.parse(getUser)
    const result = await user_api.get_limited_users(user._id)
    
    const timeInRecord = filterByStatus(result.data[0].record, 'time-in').time;
    const timeOutRecord = filterByStatus(result.data[0].record, 'time-out').time;
    const start = moment(timeInRecord, "h:mm A");
    const end = moment(timeOutRecord, "h:mm A"); 
    if (end.isBefore(start)) {
      end.add(1, "day");
    }
    let differenceHours = 0
    if(breakMinSpecific) {
      differenceHours = Math.floor((end.diff(start, "minutes") - 60) / 60);
    }
    else {
      differenceHours = Math.floor(end.diff(start, "hours", true));  
    }
    return (differenceHours - 1)
  }

  /*function getTimeDifference(currentRecord) {

      if(currentRecord && currentRecord.status === "time-out") {
        let breakInRecord
        let breakOutRecord
        let breakTimeDifferenceHours
        const timeInRecord = filterByStatus(currentRecord.record, 'time-in').time;
        const timeOutRecord = filterByStatus(currentRecord.record, 'time-out').time;
        if(currentRecord && filterByStatus(currentRecord.record, 'break-out').time !== "n/a") {
          
          breakInRecord = filterByStatus(currentRecord.record, 'break-in').time;
          breakOutRecord = filterByStatus(currentRecord.record, 'break-out').time; 
          const startBreakInRecord = moment(breakInRecord, "h:mm A");
          const endBreakOutRecord = moment(breakOutRecord, "h:mm A");
          breakTimeDifferenceHours = Math.floor(endBreakOutRecord.diff(startBreakInRecord, "hours", true)); 
        }

        const start = moment(timeInRecord, "h:mm A");
        const end = moment(timeOutRecord, "h:mm A");
        if (end.isBefore(start)) {
            end.add(1, "day");
        }
        const differenceHours = Math.floor(end.diff(start, "hours", true));
        if(currentRecord && filterByStatus(currentRecord.record, 'break-out').time !== "n/a") {
          
          setTotalHours(differenceHours - breakTimeDifferenceHours)
        }
        else {

          setTotalHours(differenceHours)
        }
      }
      
  }*/

  const handleCloseSetOpenSetOTDialog = () => {
    setOpenSetOTDialog(false)
  }

  const handleOpenOtpDialog = async () => {
    const data = { company: basicUser.company }
    const result = await user_api.get_user_by_store(data)
    if(result.status === 200) {
      setOtpDialog(true)
    }
    else {
      setOtpDialog(true)
      alert("Something went wrong please try again later")
    }
  }

  /*const handleOpenOtpDialog = async () => {
    const data = { company: basicUser.company }
    const result = await user_api.get_user_by_store(data)
    const otpData = { email: result.data[0].email }
    const sendOtp = await user_api.post_myschedule_otp(otpData)
    if(result.status === 200) {
      setOtpDialog(true)
    }
    else {
      setOtpDialog(true)
      alert("Something went wrong please try again later")
    }
  }*/

  const handleSubmitOtp = async () => {
      const data = { email: basicUser.email, otp: otp }
      const verifyResult = await user_api.post_timeAdjustment_otpVerifyV2(data)
      if(verifyResult.status === 200) {
        if(!openSetOTDialog) {
            setLoading(true)
            let totalHours = 0
            let totalHours2 = 0
            if (typeof (from) !== "string" || typeof (to) !== "string") {
              alert("Please choose start shift and end shift")
              setLoading(false)
            }
            else if (!position) {
              alert("Please choose position")
              setLoading(false)
            }
            else {
              if (typeof (from) === "string" || typeof (to) === "string") {
                const startDate = new Date(`2023-03-15T${from}`);
                const endDate = new Date(`2023-03-15T${to}`);

                const diffInMilliseconds = endDate - startDate;
                const diffInSeconds = diffInMilliseconds / 1000;
                const diffInMinutes = diffInSeconds / 60;
                const diffInHours = diffInMinutes / 60;
                const hours = breakMin / 60;
                totalHours = getTimeDifferenceSchedule(from, to)
                totalHours2 = totalHours.hours + (totalHours.minutes / 60) - hours;
              }
              
              if (isEditingExistingSchedule && specificSchedule) {
                // Update existing schedule using post_schedule_employee
                let scheduleDate;
                if (currentRecord && currentRecord.record && Object.keys(currentRecord).length > 0) {
                  if (isFutureSchedule) {
                    // Editing a future schedule, use its date
                    scheduleDate = moment(specificSchedule.date).format('L');
                  } else {
                    // User has a record for today AND has completed their shift, create for tomorrow
                    scheduleDate = moment().add(1, 'day').format('L');
                  }
                }
                 else {
                  // No record for today OR user hasn't completed their shift, edit today's schedule
                  scheduleDate = moment().format('L');
                }
                
                const updateData = {
                  uid: basicUser._id,
                  date: scheduleDate,
                  from: from,
                  to: to,
                  totalHours: totalHours2,
                  breakMin: breakMin,
                  position: position,
                  ot: specificSchedule.ot || 0,
                  nightdiff: specificSchedule.nightdiff || 0,
                  rd: specificSchedule.rd || 0
                }
                
                try {
                  const response = await user_api.post_schedule(updateData)
                  if (response.status === 200) {
                    alert("Schedule updated successfully")
                    setSaveScheduleSuccess(false)
                    setOpenCreateScheduleDialog(false)
                    setIsEditingExistingSchedule(false)
                    setLoading(false)
                  } else if (response.status === 400 && response.data && response.data.breaklistExists) {
                    // Handle breaklist validation error
                    alert(response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
                    setSaveScheduleSuccess(false)
                    setOpenCreateScheduleDialog(false)
                    setLoading(false)
                  } else {
                    alert("Something went wrong please try again later")
                    setLoading(false)
                  }
                } catch (error) {
                  console.error('Error updating schedule via OTP:', error);
                  if (error.response && error.response.status === 400 && error.response.data && error.response.data.breaklistExists) {
                    alert(error.response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
                  } else {
                    alert("Something went wrong please try again later")
                  }
                  setSaveScheduleSuccess(false)
                  setOpenCreateScheduleDialog(false)
                  setLoading(false)
                }
              } else {
                // Create new schedule using post_schedule
                const now = new Date();
                const data = {
                  uid: basicUser._id,
                  name: basicUser.displayName,
                  company: basicUser.company,
                  date: moment(addDays(now, 0)).format('L'),
                  from: from,
                  to: to,
                  totalHours: totalHours2,
                  breakMin: breakMin,
                  position: position,
                  ot: 0,
                  nightdiff: 0,
                  rd: 0
                }
                try {
                  const response = await user_api.post_schedule(data)
                  if (response.status === 200) {
                      /*ls.set("schedStatus", "true")*/
                      alert("Schedule created successfully")
                      setSaveScheduleSuccess(false)
                      setOpenCreateScheduleDialog(false)
                      setLoading(false)
                  } else if (response.status === 400 && response.data && response.data.breaklistExists) {
                    // Handle breaklist validation error
                    alert(response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
                    setSaveScheduleSuccess(false)
                    setOpenCreateScheduleDialog(false)
                    setLoading(false)
                  } else {
                    alert("Something went wrong please try again later")
                    setLoading(false)
                  }
                } catch (error) {
                  console.error('Error creating schedule via OTP:', error);
                  if (error.response && error.response.status === 400 && error.response.data && error.response.data.breaklistExists) {
                    alert(error.response.data.msg || "Cannot edit schedule. A breaklist has already been generated for this date.")
                  } else {
                    alert("Something went wrong please try again later")
                  }
                  setSaveScheduleSuccess(false)
                  setOpenCreateScheduleDialog(false)
                  setLoading(false)
                }
              }
            }
            window.location.reload()
        }
        else {
          const formattedDate = convertDate(selectedDate) 
          const data = {
            "id": basicUser._id,
            "date": formattedDate,
            "otp": otp
          }
          const getSchedule = await user_api.get_specific_schedule_with_date_v2(data)
          if (getSchedule && getSchedule.data && getSchedule.data.length > 0) {
            const data2 = {
              uid: basicUser._id,
              date: moment(addDays(new Date(selectedDate), 0)).format('L'),
              ot: ot,
              nightdiff: nsd,
            }
            const response = await user_api.post_schedule_employee(data2)
            if(response.status === 200) {
              alert("Premium values save!")
              setSavePremiumDialog(false)
              setOpenSetOTDialog(false)
              window.location.reload()
            }
          }
          else {
            alert("Set schedule for this date first!")
          } 
        }
    }
    else {
      setOtpDialog(true)
      alert("Something went wrong please try again later")
    }  
    
  }

  function getTimeDifferenceSchedule(startTime, endTime) {
    // Parse the start and end times
    const startParts = startTime.split(':');
    const endParts = endTime.split(':');

    // Create Date objects for the times
    const startDate = new Date();
    startDate.setHours(startParts[0], startParts[1], 0, 0);

    const endDate = new Date(startDate);
    endDate.setHours(endParts[0], endParts[1], 0, 0);

    // Handle the case where end time is on the next day
    if (endDate <= startDate) {
      endDate.setDate(endDate.getDate() + 1);
    }

    // Calculate the difference in milliseconds
    const timeDifferenceMilliseconds = endDate - startDate;

    // Convert the difference to hours and minutes
    const hoursDifference = Math.floor(timeDifferenceMilliseconds / (1000 * 60 * 60));
    const minutesDifference = Math.floor((timeDifferenceMilliseconds % (1000 * 60 * 60)) / (1000 * 60));

    return {
      hours: hoursDifference,
      minutes: minutesDifference
    };
  }

  const handleSaveSchedule = async () => {
    setLoading(true)
    if (typeof (from) !== "string" || typeof (to) !== "string") {
      alert("Please choose start shift and end shift")
      setLoading(false)
    }
    else if (!position) {
      alert("Please choose position")
      setLoading(false)
    }
    else {
      setSaveScheduleSuccess(true)
      setLoading(false)
    }
  }

  const handleOpenCreateScheduleDialog = async () => {
    // If we have a specificSchedule, we're editing it, so first check if breaklist exists
    if (specificSchedule) {
      try {
        setLoading(true);
        
        // Check if a breaklist has been generated for this date
        const scheduleDate = specificSchedule.date ? moment(specificSchedule.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        const breaklistCheckData = {
          date: scheduleDate,
          company: basicUser.company
        };
        
        const breaklistCheck = await user_api.check_breaklist(breaklistCheckData);
        
        if (breaklistCheck.status === 201) {
          // Breaklist exists, show error message
          alert('Cannot edit schedule. A breaklist has already been generated for this date. Please contact your supervisor to delete the existing breaklist before making changes.');
          setLoading(false);
          return;
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error checking breaklist:', error);
        setLoading(false);
        alert('Error validating schedule. Please try again.');
        return;
      }
    }

    // If we have a specificSchedule, we're editing it, so populate the form fields
    if (specificSchedule) {
      setFrom(specificSchedule.from || '')
      setTo(specificSchedule.to || '')
      setBreakMin(specificSchedule.breakMin || 0)
      setPosition(specificSchedule.position || '')
      setIsEditingExistingSchedule(true)
    } else {
      // Reset to defaults for new schedule
      setFrom('')
      setTo('')
      setBreakMin(0)
      setPosition('')
      setIsEditingExistingSchedule(false)
    }
    setOpenCreateScheduleDialog(true)
  }

  const handleCloseCreateScheduleDialog = () => {
    setOpenCreateScheduleDialog(false)
    setIsEditingExistingSchedule(false)
  }

  const handleChangeOtMinutes = (e) => {
    if(e === 30) {
      setOtMinutes(30)
      setOt(otHours + .5)
    }
    else {
      setOtMinutes(0)
      setOt(otHours)
    }
  }

  const handleChangeNsdMinutes = (e) => {
    if(e === 30) {
      setNsdMinutes(30)
      setNsd(nsdHours + .5)
    }
    else {
      setNsdMinutes(0)
      setNsd(nsdHours)
    }
  }

  const handleChangeOtHours = (e) => {
    setOtHours(e)
    if(otMinutes === 30) {
      setOt(parseFloat(e) + 0.5)
    }
    else {
      setOt(e)
    }
  }

  const handleChangeNsdHours = (e) => {
    setNsdHours(e)
    if(nsdMinutes === 30) {
      setNsd(parseFloat(e) + 0.5)
    }
    else {
      setNsd(e)
    }
  }

  // Function to fetch the next available unconfirmed schedule
  const fetchNextAvailableSchedule = async (userId) => {
    try {
      // Get today's and tomorrow's dates
      const today = moment().format('YYYY-MM-DD')
      
      // Fetch today's and tomorrow's schedules in parallel to save time
      const todayData = { id: userId, date: today }
      
      const [userResult, todaySchedules] = await Promise.all([
        user_api.get_limited_users(userId),
        user_api.get_specific_schedule_with_date_v2(todayData)
      ])
      
      // Check if user has timed in today
      const hasRecord = moment(userResult.data[0].date).format('YYYY-MM-DD') === today
      
      // Process today's schedules first
      if (todaySchedules && todaySchedules.data && todaySchedules.data.length > 0) {
        // Sort schedules by the "from" field to get earliest first
        const sortedTodaySchedules = [...todaySchedules.data].sort((a, b) => {
          const timeA = moment(a.from, "HH:mm")
          const timeB = moment(b.from, "HH:mm")
          return timeA - timeB
        })
        
        // If no record, return the earliest schedule regardless of confirmation
        if (!hasRecord || userResult.data[0].status === "time-in") {
          return sortedTodaySchedules[0]
        }
        
        // Has record, look for the first unconfirmed schedule
        const unconfirmedSchedule = sortedTodaySchedules.find(s => !s.confirmed)
        if (unconfirmedSchedule) {
          return unconfirmedSchedule
        }
        
        // All today's schedules are confirmed, check tomorrow
      }

      const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD')
      const tomorrowData = { id: userId, date: tomorrow }
      const tomorrowSchedules = await user_api.get_specific_schedule_with_date_v2(tomorrowData)
      
      // Process tomorrow's schedules
      if (tomorrowSchedules && tomorrowSchedules.data && tomorrowSchedules.data.length > 0) {
        // Sort tomorrow's schedules by start time
        const sortedTomorrowSchedules = [...tomorrowSchedules.data].sort((a, b) => {
          const timeA = moment(a.from, "HH:mm")
          const timeB = moment(b.from, "HH:mm")
          return timeA - timeB
        })
        
        // Return the earliest unconfirmed schedule for tomorrow
        const nextUnconfirmed = sortedTomorrowSchedules.find(s => !s.confirmed)
        if (nextUnconfirmed) {
          return nextUnconfirmed
        }
        
        // If all tomorrow's schedules are confirmed, return the earliest one
        return sortedTomorrowSchedules[0]
      }
      
      // No schedules found
      return null
    } catch (error) {
      console.error('Error fetching next available schedule:', error)
      return null
    }
  }

  // Helper function to check if current time is at least 2 hours before schedule start
  const isTimeBeforeScheduleStart = () => {
    if (!specificSchedule || !specificSchedule.from || !specificSchedule.date) {
      return false
    }

    try {
      // Get current date and time in Manila timezone
      const now = moment().tz('Asia/Manila')

      // Combine schedule date and start time
      const scheduleDateTime = moment.tz(`${specificSchedule.date} ${specificSchedule.from}`, 'YYYY-MM-DD HH:mm', 'Asia/Manila')

      // Check if current time is at least 2 hours before schedule start
      const twoHoursBefore = scheduleDateTime.clone().subtract(2, 'hours')

      return now.isBefore(twoHoursBefore)
    } catch (error) {
      console.error('Error checking schedule time:', error)
      return false
    }
  }

  const renderScheduleConfirmation = () => {
    // Always show the button, regardless of schedule confirmation status
    return (
      <>
        <Button
          id='confirmBtn'
          variant="outlined"
          disabled={!userTimedOut}
          sx={{
            borderRadius: "0",
            borderColor: "#2194F3",
            borderWidth: "0px 0px 0px 1px",
            minWidth: { xs: "50px", sm: "100px" },
            textTransform: "none",
            fontWeight: "bold",
            fontSize: { xs: ".7rem", sm: ".8rem" },
            padding: { xs: "0 4px", sm: "0 8px" },
            "&:hover": {
              backgroundColor: ls.get("confirmStatus") && ls.get("confirmStatus") === "true" ? "white" :
                userTimedOut && !isTimeBeforeScheduleStart() ? "#1976D2" :
                isTimeBeforeScheduleStart() ? "grey" : "#cccccc"
            },
            pointerEvents: (ls.get("confirmStatus") && ls.get("confirmStatus") === "true") || !userTimedOut ? "none" : "auto",
            backgroundColor: ls.get("confirmStatus") && ls.get("confirmStatus") === "true" ? "white" : userTimedOut && !isTimeBeforeScheduleStart() ? "#2194F3" : isTimeBeforeScheduleStart() ? "white" : "#cccccc",
            color: ls.get("confirmStatus") && ls.get("confirmStatus") === "true" ? "#2194F3" : userTimedOut && !isTimeBeforeScheduleStart() ? "white" : isTimeBeforeScheduleStart() ? "#FF6B6B" : "#666666",
          }}
          onClick={ls.get("confirmStatus") && ls.get("confirmStatus") === "true" ? undefined : () => handleConfirmScheduleExtend()}
        >
          {ls.get("confirmStatus") && ls.get("confirmStatus") === "true" ? "Confirmed" : !userTimedOut ? "Time Out First" : isTimeBeforeScheduleStart() ? "Too Early" : "Confirm"}
        </Button>
      </>
    );
  };

  // Function to calculate total hours based on the four cases defined
  const calculateTotalHours = async (userData, scheduleData, hasTimedIn, hasConfirmedSchedule, userRecordData = null) => {
    try {
      // Case 1: User has not timed in - display total hours as 0
      if (!hasTimedIn) {
        return 0;
      }
      
      // Use scheduleData directly if provided and contains the required fields
      const todaySchedule = scheduleData && scheduleData.from && scheduleData.to ? scheduleData : null;
      
      // If we need to fetch the schedule (not provided or incomplete data)
      let fetchedSchedule = null;
      if (!todaySchedule) {
        // Get the current day's schedule only if not provided
        const today = moment().format('YYYY-MM-DD');
        const todayData = {
          id: userData._id,
          date: today
        };
        
        // Only fetch user records if not provided
        const promises = [user_api.get_specific_schedule_with_date_v2(todayData)];
        if (!userRecordData) {
          promises.push(user_api.get_limited_users(userData._id));
        }
        
        const results = await Promise.all(promises);
        const todayScheduleResponse = results[0];
        const userResult = userRecordData ? null : results[1];

        // Process schedule data if available
        if (todayScheduleResponse.data.length > 0) {
          // Sort schedules to get the earliest one
          fetchedSchedule = [...todayScheduleResponse.data].sort((a, b) => {
            const timeA = moment(a.from, "HH:mm");
            const timeB = moment(b.from, "HH:mm");
            return timeA - timeB;
          })[0]; // Take the earliest schedule
        }
        
        // Use provided user record data or fetch it
        const recordSource = userRecordData || userResult.data[0];
        const recordData = {
          timeInRecord: filterByStatus(recordSource.record, 'time-in').time,
          timeOutRecord: filterByStatus(recordSource.record, 'time-out').time,
          breakInRecord: filterByStatus(recordSource.record, 'break-in').time,
          breakOutRecord: filterByStatus(recordSource.record, 'break-out').time
        };
        
        return calculateHoursFromData(fetchedSchedule || scheduleData, recordData);

      } else {
        // Use the provided scheduleData directly
        // Use provided user record data or fetch it
        let recordSource;
        if (userRecordData) {
          recordSource = userRecordData;
        } else {
          const userResult = await user_api.get_limited_users(userData._id);
          recordSource = userResult.data[0];
        }
        
        const recordData = {
          timeInRecord: filterByStatus(recordSource.record, 'time-in').time,
          timeOutRecord: filterByStatus(recordSource.record, 'time-out').time,
          breakInRecord: filterByStatus(recordSource.record, 'break-in').time,
          breakOutRecord: filterByStatus(recordSource.record, 'break-out').time
        };
        
        return calculateHoursFromData(todaySchedule, recordData);
      }
    } catch (error) {
      console.error('Error calculating total hours:', error);
      return 0;
    }
  };
  
  // Helper function to perform the actual hour calculations
  const calculateHoursFromData = (scheduleData, recordData) => {
    const { timeInRecord, timeOutRecord, breakInRecord, breakOutRecord } = recordData;
    
    // Calculate schedule's max hours
    let scheduleHours = 0;
    let breakMinutes = 0;
    
    if (scheduleData) {
      if (scheduleData.from && scheduleData.to) {
        const scheduleStart = moment(scheduleData.from, "HH:mm");
        const scheduleEnd = moment(scheduleData.to, "HH:mm");
        
        // Handle schedules that cross midnight
        if (scheduleEnd.isBefore(scheduleStart)) {
          scheduleEnd.add(1, "day");
        }
        
        const scheduleTotalMinutes = scheduleEnd.diff(scheduleStart, "minutes");
        scheduleHours = scheduleTotalMinutes / 60;
      } else if (scheduleData.totalHours) {
        // Fallback to totalHours if from/to not available
        scheduleHours = parseFloat(scheduleData.totalHours);
      }
      
      breakMinutes = scheduleData.breakMin || 0;
    }
    
    const breakHours = breakMinutes / 60;
    const maxAllowedHours = Math.max(0, scheduleHours - breakHours);
    
    // If user hasn't timed out, calculate hours elapsed since time-in
    if (timeOutRecord === "n/a") {
      const timeInMoment = moment(timeInRecord, "h:mm A");
      const currentTime = moment();
      
      // Calculate minutes elapsed since time-in
      const minutesElapsed = currentTime.diff(timeInMoment, "minutes");
      
      // Calculate break time from records if available
      let effectiveBreakMinutes = 0;
      
      if (breakInRecord !== "n/a" && breakOutRecord !== "n/a") {
        // Break completed
        const breakStart = moment(breakInRecord, "h:mm A");
        const breakEnd = moment(breakOutRecord, "h:mm A");
        
        if (breakEnd.isBefore(breakStart)) {
          breakEnd.add(1, "day");
        }
        
        effectiveBreakMinutes = breakEnd.diff(breakStart, "minutes");
      } else if (breakInRecord !== "n/a" && breakOutRecord === "n/a") {
        // On break currently
        const breakStart = moment(breakInRecord, "h:mm A");
        effectiveBreakMinutes = currentTime.diff(breakStart, "minutes");
      } else if (scheduleData && minutesElapsed > breakMinutes) {
        // Use schedule break if no break records and enough time has passed
        effectiveBreakMinutes = breakMinutes;
      }
      
      // Calculate hours worked so far (excluding break time)
      const hoursWorkedSoFar = Math.max(0, (minutesElapsed - effectiveBreakMinutes) / 60);
      
      // Cap at the maximum allowed hours from schedule if we have schedule data
      return scheduleData ? Math.min(hoursWorkedSoFar, maxAllowedHours) : hoursWorkedSoFar;
    }
    
    // User has timed out - calculate actual hours worked
    const start = moment(timeInRecord, "h:mm A");
    const end = moment(timeOutRecord, "h:mm A");
    
    if (end.isBefore(start)) {
      end.add(1, "day");
    }
    
    // Calculate total minutes worked
    const totalMinutesWorked = end.diff(start, "minutes");
    
    // Calculate actual break time from records if available
    let actualBreakMinutes = breakMinutes; // Default to schedule break
    
    if (breakInRecord !== "n/a" && breakOutRecord !== "n/a") {
      const breakStart = moment(breakInRecord, "h:mm A");
      const breakEnd = moment(breakOutRecord, "h:mm A");
      
      if (breakEnd.isBefore(breakStart)) {
        breakEnd.add(1, "day");
      }
      
      actualBreakMinutes = breakEnd.diff(breakStart, "minutes");
    }
    
    // Convert to hours, subtracting the break time
    const actualHoursWorked = (totalMinutesWorked - actualBreakMinutes) / 60;
    
    // Cap the hours at the schedule's max hours if we have schedule data
    return scheduleData ? Math.min(actualHoursWorked, maxAllowedHours) : actualHoursWorked;
  };

  const fetchRecentRecords = async (userId) => {
    try {
      setLoadingRecords(true);
      const result = await user_api.get_limited_usersV4(userId, 5);
      if (result.data && result.data.length > 0) {
        setRecentRecords(result.data);
      } else {
        // If no records found, set empty array
        setRecentRecords([]);
      }
    } catch (error) {
      console.error('Error fetching recent records:', error);
      enqueueSnackbar('Failed to fetch history records. Please try again.', { variant: 'error' });
      setRecentRecords([]);
    } finally {
      setLoadingRecords(false);
    }
  };

  // Helper function to format date for display
  const formatRecordDate = (dateString) => {
    return moment(dateString).format('MMM DD, YYYY');
  }

  const toggleCardExpand = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  const renderHistoryCard = (record) => {
    const timeIn = filterByStatus(record.record, 'time-in').time;
    const breakIn = filterByStatus(record.record, 'break-in').time;
    const breakOut = filterByStatus(record.record, 'break-out').time;
    const timeOut = filterByStatus(record.record, 'time-out').time;
    

    // Format schedule times - handle both 24h and 12h formats
    const formatScheduleTime = (time) => {
      if (!time) return 'N/A';
      if (time.includes(' ')) return time; // Already in 12h format
      return convertToAmPm(time);
    };

    const scheduleStart = formatScheduleTime(record.startShift);
    const scheduleEnd = formatScheduleTime(record.endShift);
    const breakDuration = record.breakMinutes || '0';

    const handleCopyProcessId = (id) => {
      navigator.clipboard.writeText(id)
        .then(() => {
          enqueueSnackbar("Process ID copied to clipboard", { variant: "success" });
        })
        .catch((err) => {
          console.error("Failed to copy process ID:", err);
          enqueueSnackbar("Failed to copy process ID", { variant: "error" });
        });
    };

    return (
      <Card 
        key={record._id}
        className={classes.historyCard}
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          border: '1px solid #2194F3',
          borderRadius: '8px',
          mb: 2
        }}
      >
        <CardContent sx={{ p: 2 }}>
          {/* First card section - Process ID */}
          <Box sx={{ mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
            <Typography variant="caption" color="text.secondary" fontWeight="bold">
              Process ID: {record._id}
            </Typography>
            <IconButton 
              size="small" 
              onClick={() => handleCopyProcessId(record._id)}
              sx={{ ml: 1 }}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Second card section - Blue header section */}
          <Box sx={{ 
            mb: 1, 
            pb: 1, 
            borderBottom: '1px solid #eee',
            backgroundColor: '#2194F3',
            borderRadius: '4px',
            p: 1,
            width: '100%'
          }}>
            <Grid container spacing={0.5} sx={{ width: '100%', mb: 1 }}>
              <Grid item xs={6} sm={4}>
                <Typography variant="caption" component="div" color="white" sx={{ opacity: 0.9 }}>Date</Typography>
                <Typography variant="body2" color="white">{formatRecordDate(record.date)}</Typography>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Typography variant="caption" component="div" color="white" sx={{ opacity: 0.9 }}>Position</Typography>
                <Typography variant="body2" color="white">{record.position || 'N/A'}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={0.5} sx={{ width: '100%' }}>
              <Grid item xs={4} sm={4}>
                <Typography variant="caption" component="div" color="white" sx={{ opacity: 0.9 }}>Start Shift</Typography>
                <Typography variant="body2" color="white">{scheduleStart}</Typography>
              </Grid>
              <Grid item xs={4} sm={4}>
                <Typography variant="caption" component="div" color="white" sx={{ opacity: 0.9 }}>End Shift</Typography>
                <Typography variant="body2" color="white">{scheduleEnd}</Typography>
              </Grid>
              <Grid item xs={4} sm={4}>
                <Typography variant="caption" component="div" color="white" sx={{ opacity: 0.9 }}>Break (min)</Typography>
                <Typography variant="body2" color="white">{breakDuration}</Typography>
              </Grid>
            </Grid>
          </Box>

          {/* Third card section - Time records and late minutes */}
          <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={4} sm={4}>
              <Typography variant="caption" component="div" color="text.secondary">Time In</Typography>
              <Typography variant="body2" color="primary.main">
                {timeIn || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography variant="caption" component="div" color="text.secondary">Break In</Typography>
              <Typography variant="body2" color="success.main">
                {breakIn || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography variant="caption" component="div" color="text.secondary">Break Out</Typography>
              <Typography variant="body2" color="success.main">
                {breakOut || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography variant="caption" component="div" color="text.secondary">Time Out</Typography>
              <Typography variant="body2" color="error.main">
                {timeOut || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography variant="caption" component="div" color="text.secondary">Late (min)</Typography>
              <Typography variant="body2" color="warning.main">
                {record.lateMinutes || '0'}
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography variant="caption" component="div" color="text.secondary">Total Hours</Typography>
              <Typography variant="body2" color="info.main">
                {record.hoursWorked}
              </Typography>
            </Grid>
          </Grid>

          {/* Fourth card section - Premium Hours (Collapsible) */}
          <Box sx={{ 
            borderTop: '1px solid #eee',
            pt: 2,
            position: 'relative'
          }}>
            <Box sx={{
              justifyContent: 'space-between',
              display: 'flex',
              alignItems: 'baseline',
              mb: 1
            }}>
              {expandedCards[record._id] ? (
                    <Grid container spacing={1}>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="caption" component="div" color="text.secondary">Overtime (hrs)</Typography>
                        <Typography variant="body2" color="secondary.main">
                        {record.overtime || '0'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="caption" component="div" color="text.secondary">Night Shift (hrs)</Typography>
                        <Typography variant="body2" color="secondary.main">
                        {record.nightShift || '0'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="caption" component="div" color="text.secondary">Rest Day (hrs)</Typography>
                        <Typography variant="body2" color="secondary.main">
                        {record.restday || '0'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <Typography variant="caption" component="div" color="text.secondary">Holiday (hrs)</Typography>
                        <Typography variant="body2" color="secondary.main">
                        {record.holidayHours || '0'}
                        </Typography>
                    </Grid>
                    </Grid>
              ) : (
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                  >
                    Premium Hours
                  </Typography>
              )}
              
              <Button 
                size="small" 
                onClick={() => toggleCardExpand(record._id)}
                endIcon={<Icon icon="mdi:chevron-down" style={{ transform: expandedCards[record._id] ? 'rotate(180deg)' : 'rotate(0deg)' }} />}
              >
                {expandedCards[record._id] ? 'Hide' : 'View'}
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  return (
    <Page title="Dashboard | Time in">
{/*      <FacebookProvider appId={process.env.REACT_APP_FB_APP_ID} chatSupport>
        <CustomChat pageId={process.env.REACT_APP_FB_PAGE_ID} minimized={false} />
      </FacebookProvider>*/}
      {!open ? (
        <>
          <Box 
            sx={{
              p: { xs: 1, sm: 1.5, md: 2 },
              width: '100%', 
              backgroundColor: '#2194F3', 
              color: '#fff', 
              borderRadius: '10px'
            }}
          >
            <Grid container direction="row" justifyContent="space-between">
              <Grid item xs={9} sm={9}>
                <Box sx={{
                  display: 'flex', 
                  alignItems: 'center',
                  gap: { xs: 0.5, sm: 1 },
                  justifyContent: 'start'
                }}>
                  {basicUser?.image ? (
                    <Avatar 
                      src={basicUser.image} 
                      sx={{
                        width: { xs: '3rem', sm: '3rem', md: '4rem' }, 
                        height: { xs: '3rem', sm: '3rem', md: '4rem' }
                      }} 
                    />
                  ) : (
                    <Icon 
                      icon="iconoir:user-circle" 
                      style={{
                        fontSize: { xs: '3rem', sm: '3rem', md: '4rem' }, 
                        color: 'white'
                      }} 
                    />
                  )}
                  <Box sx={{
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'start', 
                    justifyContent: 'start',
                    width: '80%'
                  }}>
                    {/* Display Name without Edit Button */}
                    <Typography 
                      variant="body2" 
                      sx={{
                        fontSize: { xs: '.8rem', sm: '.8rem', md: '.9rem' },
                        margin: 0,
                        whiteSpace: 'normal',
                        textOverflow: 'clip',
                        overflow: 'visible',
                      }}
                    >
                      {basicUser.displayName ? basicUser.displayName : `Loading`}
                    </Typography>

                    {/* Company Name without Edit Button */}
                    <Typography
                      variant="body2" 
                      sx={{
                        fontSize: { xs: '.8rem', sm: '.8rem', md: '.9rem' },
                        margin: 0,
                        whiteSpace: 'normal',  // Changed from 'nowrap' to 'normal' to enable wrapping
                        overflow: 'visible',   // Changed from 'hidden' to 'visible'
                        textOverflow: 'clip',  // Changed from 'ellipsis' to 'clip'
                        lineHeight: 1.2,       // Added to control spacing between wrapped lines
                        wordBreak: 'break-word' // Added to ensure long words will also break if needed
                      }}
                    >
                      {basicUser.company ? basicUser.company : 'Loading'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={3} sm={3}>
                <Box sx={{
                  display: 'flex', 
                  flexDirection: 'column', 
                  alignItems: 'center', 
                  py: { xs: '5px', sm: '8px', md: '10px' },
                  pr: { xs: '5px', sm: 0 }
                }}>
                  <Typography 
                    variant="body2"
                    sx={{
                      fontSize: { xs: '.8rem', sm: '.8rem', md: '.9rem' },
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <Box fontWeight="fontWeightMedium" display="inline">
                      <Clock format={'ll'} ticking={true} timezone={'Asia/Manila'} />
                    </Box>
                  </Typography>
                  <Typography 
                    variant="body2"
                    sx={{
                      fontSize: { xs: '.8rem', sm: '.8rem', md: '.9rem' },
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <Box fontWeight="fontWeightMedium" display="inline">
                      <Clock format={'HH:mm:ss'} ticking={true} timezone={'Asia/Manila'} />
                    </Box>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
            <Box sx={{mt: '0rem', width: '100%'}}>
              <Grid spacing={0} direction="column" alignItems="center" justify="center" style={{minHeight: '60vh', width: '100%'}}>
                <>
                  <Box container>
                      <>
                        <Suspense fallback={<></>}>
                          {surveyDone === false ? <SurveyForm /> : null}
                        </Suspense>
                        {mySchedule 
                          ?
                            <>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={1} mx={1}>
                              <Typography variant="h6">My Schedule</Typography>
                              {ls.get("confirmStatus") === "" || ls.get("confirmStatus") === "false"
                                ?
                                  <Button
                                    onClick={handleOpenCreateScheduleDialog}
                                    size="small"
                                    variant="contained"
                                    startIcon={<EditIcon fontSize="small" />}
                                    sx={{
                                      color: 'white',
                                      border: 1,
                                      borderRadius: 1.5,
                                      borderColor: "#2194F3",
                                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                                      '&:hover': {
                                        backgroundColor: 'rgba(33, 148, 243, 0.8)',
                                        transform: 'scale(1.05)',
                                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)'
                                      },
                                      transition: 'all 0.2s ease-in-out',
                                      textTransform: 'none',
                                      backgroundColor: 'primary.main',
                                      ml: 2
                                    }}
                                  >
                                    Edit
                                  </Button>   
                                :
                                  ''
                              }
                               
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "stretch",
                                border: 1,
                                borderRadius: 1.5,
                                borderColor: "#2194F3",
                                overflow: "hidden",
                                width: "100%",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flex: 1,
                                  overflowX: isVerySmallScreen ? "auto" : "visible", // Enable horizontal scrolling only on screens below 400px
                                  minWidth: isVerySmallScreen ? 0 : "auto", // Allow flex item to shrink below content size only on small screens
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    gap: { xs: 1, sm: 2, md: 3 },
                                    my: 1.5,
                                    alignItems: "center",
                                    mx: .5,
                                    minWidth: "auto", // Ensure minimum width for content only on screens below 400px
                                    width: "100%"
                                  }}
                                >
                                  <Box sx={{ textAlign: "center", flexShrink: 1, minWidth: "auto" }}>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem",
                                      whiteSpace: "nowrap",
                                      fontWeight: "bold",
                                      mb: 1.5
                                    }}
                                  >
                                    Position
                                    </Typography>
                                    <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem", 
                                      color: "blue",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {specificSchedule?.position ? specificSchedule.position : "-"}
                                  </Typography>
                                  </Box>
                                  <Box sx={{ textAlign: "center", flexShrink:  1, minWidth: "auto" }}>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem",
                                      whiteSpace: "nowrap",
                                      fontWeight: "bold",
                                      mb: 1.5
                                    }}
                                  >
                                    Start Shift
                                  </Typography>
                                    <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem", 
                                      color: "green",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {specificSchedule?.from ? convertToAmPm(specificSchedule.from) : "00:00"}
                                  </Typography>
                                </Box>
                                <Box sx={{ textAlign: "center", flexShrink: 1, minWidth: "auto" }}>
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem",
                                      whiteSpace: "nowrap",
                                      fontWeight: "bold",
                                      mb: 1.5
                                    }}
                                  >
                                    End Shift
                                  </Typography>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem", 
                                      color: "green",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {specificSchedule?.to ? convertToAmPm(specificSchedule.to) : "00:00"}
                                  </Typography>
                                </Box>
                                <Box sx={{ textAlign: "center", flexShrink: 1, minWidth: "auto" }}>
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem",
                                      whiteSpace: "nowrap",
                                      fontWeight: "bold",
                                      mb: 1.5
                                    }}
                                  >
                                    Date
                                  </Typography>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontSize: ".8rem", 
                                      color: "red",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {specificSchedule?.date ? formatDate(specificSchedule.date.split("T")[0]) : "-"}
                                  </Typography>
                                </Box>
                                </Box>
                              </Box>
                              {renderScheduleConfirmation()}
                            </Box> 
                          </>
                          :
                            ''
                        }
                          
                          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={4} mx={1}>
                            <Typography variant="h6">My Time Record</Typography>
                            <Button
                              onClick={() => setOpenSetOTDialog(true)}
                              size="small"
                              variant="contained"
                              startIcon={<AddCircleIcon fontSize="small" />}
                              disabled={!userTimedOut}
                              sx={{
                                border: 1,
                                borderRadius: 1.5,
                                borderColor: "#2194F3",
                                color: 'white',
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                                '&:hover': {
                                  backgroundColor: 'rgba(33, 148, 243, 0.8)',
                                  transform: 'scale(1.05)',
                                  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
                                },
                                transition: 'all 0.2s ease-in-out',
                                textTransform: 'none',
                                backgroundColor: userTimedOut ? 'primary.main' : '#cccccc',
                                ml: 2
                              }}
                            >
                              Add OT
                            </Button>
                          </Box>
                          <Box
                            border={1}
                            borderRadius={1.5}
                            borderColor="#2194F3"
                            sx={{
                              display: 'flex',
                              gap: '.25rem',
                              padding: '.70rem',
                              marginRight: '.5rem',
                              marginTop: '.5rem',
                              justifyContent: 'space-around',
                              width: '100%',
                              marginBottom: '1rem',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease-in-out',
                              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                              '&:hover': {
                                backgroundColor: 'rgba(33, 148, 243, 0.08)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
                              },
                              '&:active': {
                                transform: 'translateY(0px)',
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                              }
                            }}
                            onClick={handleClickCurrentShift}
                          >
                            <Box 
                              sx={{ 
                                alignContent: 'center', 
                                textAlign: 'center', 
                                flexShrink: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%'
                              }}
                            >
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: "#2194F3",
                                  fontSize: '.8rem',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 'bold',
                                  mb: 1.5
                                }}
                              >
                                Time In
                              </Typography>
                              <Typography 
                                variant="caption" 
                                sx={{
                                  fontSize: '.8rem',
                                  color: 'blue',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {currentRecord ? filterByStatus(currentRecord.record, 'time-in').time : 'N/A'}
                              </Typography>
                            </Box>

                            <Box 
                              sx={{ 
                                alignContent: 'center', 
                                textAlign: 'center', 
                                flexShrink: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%'
                              }}
                            >
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: "#2194F3",
                                  fontSize: '.8rem',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 'bold',
                                  mb: 1.5
                                }}
                              >
                                Break In
                              </Typography>
                              <Typography 
                                variant="caption" 
                                sx={{
                                  fontSize: '.8rem',
                                  color: 'green',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {currentRecord ? filterByStatus(currentRecord.record, 'break-in').time : 'N/A'}
                              </Typography>
                            </Box>

                            <Box 
                              sx={{ 
                                alignContent: 'center', 
                                textAlign: 'center', 
                                flexShrink: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%'
                              }}
                            >
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: "#2194F3",
                                  fontSize: '.8rem',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 'bold',
                                  mb: 1.5
                                }}
                              >
                                Break Out
                              </Typography>
                              <Typography 
                                variant="caption" 
                                sx={{
                                  fontSize: '.8rem',
                                  color: 'green',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {currentRecord ? filterByStatus(currentRecord.record, 'break-out').time : 'N/A'}
                              </Typography>
                            </Box>

                            <Box 
                              sx={{ 
                                alignContent: 'center', 
                                textAlign: 'center', 
                                flexShrink: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%'
                              }}
                            >
                              <Typography 
                                variant="caption" 
                                sx={{ 
                                  color: "#2194F3",
                                  fontSize: '.8rem',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 'bold',
                                  mb: 1.5
                                }}
                              >
                                Time Out
                              </Typography>
                              <Typography 
                                variant="caption" 
                                sx={{
                                  fontSize: '.8rem',
                                  color: 'red',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {currentRecord ? filterByStatus(currentRecord.record, 'time-out').time : 'N/A'}
                              </Typography>
                            </Box>
                            
 {/*                           <Box 
                              sx={{ 
                                alignContent: 'center', 
                                textAlign: 'center', 
                                flexShrink: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '100%'  // Changed from 'center' to 'space-between' to match others
                              }}
                            >
                              <Box>
                                <Typography 
                                  variant="caption" 
                                  sx={{ 
                                    color: "#2194F3",
                                    fontSize: '.8rem',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',
                                    display: 'block',
                                    mb: 0
                                  }}
                                >
                                  Total Hours
                                </Typography>
                                
                                <Typography
                                  variant="caption" 
                                  sx={{ 
                                    color: "#2194F3",
                                    fontSize: '.55rem',
                                    whiteSpace: 'nowrap',
                                    display: 'block',  // Added consistent margin bottom
                                  }}
                                >
                                  (without overtime)
                                </Typography>
                              </Box>
                              
                              <Typography 
                                variant="caption" 
                                sx={{
                                  fontSize: '.8rem',
                                  color: 'orange',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {Math.max(0, parseInt(totalHours || 0))}
                              </Typography>
                            </Box>*/}
                          </Box>
                        </>
                  </Box>  
                </>
                {/*  <label>{location.latitude}</label>*/}
                {isLoading ? <Loading /> : <ButtonMemo />}
                  <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" mt={4} mx={1}>
                    <Box display="flex" justifyContent="flex-start" width="100%" mb={1}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Bulletin Board
                      </Typography>
                    </Box>
                    {loadingBanner === false ? (
                      broadcast.length > 0 && selectedBanner !== false ? (
                        <Box>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'start',
                              marginBottom: '-15px',
                              zIndex: 1,
                              position: 'relative',
                            }}
                          >
                            <Icon
                              icon="solar:close-square-bold-duotone"
                              style={{fontSize: '2rem', color: '#c4c0c0'}}
                              onClick={() => {
                                handleCloseBanner()
                              }}
                            />
                          </Box>
                          <Carousel
                            autoplay={true}
                            withoutControls={true}
                            wrapAround={true}
                            cellSpacing={10}
                            cellAlign="center"
                            slidesToShow={1.3}
                            transitionMode={'scroll3d'}
                            style={{
                              height: { xs: '15vh', sm: '15vh', md: '25vh' },
                              width: { xs: '25vh', sm: '25vh', md: '35vh' },
                              margin: 'auto', // Optional: Center the carousel horizontally
                            }}
                          >
                            {broadcast
                              .filter((banner) => banner.toggle !== false) // Only show banners with toggle === true or undefined
                              .sort((a, b) => (a.rank ?? Infinity) - (b.rank ?? Infinity)) // Sort by rank (undefined ranks go last)
                              .map((banner) => (
                                <div key={banner._id}>
                                  <img
                                    src={banner.img}
                                    style={{ height: '25vh' }}
                                    onClick={() => {
                                      if (banner.link) {
                                        window.open(banner.link);
                                      } else {
                                        setpromotionDialogState((prevState) => ({
                                          ...prevState,
                                          showDialog: true,
                                          promotion: banner,
                                        }));
                                      }
                                    }}
                                  />
                                  <PromotionDialog
                                    showDialog={promotionDialogState.showDialog}
                                    promotion={promotionDialogState.promotion}
                                    onClose={() => {
                                      setpromotionDialogState((prevState) => ({
                                        ...prevState,
                                        showDialog: false,
                                      }));
                                    }}
                                  />
                                </div>
                              ))}
                          </Carousel>
                        </Box>
                      ) : (
                        <>
                          {banners.length > 0 && selectedBanner !== false ? (
                            <Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'start',
                                  marginBottom: '-15px',
                                  zIndex: 1,
                                  position: 'relative',
                                }}
                              >
                                <Icon
                                  icon="solar:close-square-bold-duotone"
                                  style={{fontSize: '2rem', color: '#c4c0c0'}}
                                  onClick={() => {
                                    handleCloseBanner()
                                  }}
                                />
                              </Box>
                              <Carousel
                                autoplay={true}
                                withoutControls={true}
                                wrapAround={true}
                                cellSpacing={10}
                                cellAlign="center"
                                slidesToShow={1.3}
                                transitionMode={'scroll3d'}
                                style={{
                                  height: { xs: '15vh', sm: '15vh', md: '25vh' },
                                  width: { xs: '25vh', sm: '25vh', md: '35vh' },
                                  margin: 'auto', // Optional: Center the carousel horizontally
                                }}
                              >
                                {banners.map((banner, key) => {
                                  return (
                                    <div key={banner._uid}>
                                      <img
                                        src={banner.image.filename}
                                        onClick={() => {
                                          if (banner.redirect) {
                                            window.location.href = banner.link
                                          } else {
                                            setpromotionDialogState((prevState) => ({
                                              ...prevState,
                                              showDialog: true,
                                              promotion: banner,
                                            }))
                                          }
                                        }}
                                      />
                                      <PromotionDialog
                                        showDialog={promotionDialogState.showDialog}
                                        promotion={promotionDialogState.promotion}
                                        onClose={() => {
                                          setpromotionDialogState((prevState) => ({
                                            ...prevState,
                                            showDialog: false,
                                          }))
                                        }}
                                      />
                                    </div>
                                  )
                                })}
                              </Carousel>
                            </Box>
                          ) : (
                            ''
                          )}
                        </>
                      )
                    ) : (
                      <Loading />
                    )}

                    {loadingBanner === false && !selectedBanner && (
                      <>
                        {initialBanner && (
                          <Box 
                            onClick={handleOpenBanner}
                            sx={{
                              display: 'flex', 
                              justifyContent: 'center', 
                              alignItems: 'center', 
                              marginTop: '25px',
                              cursor: 'pointer',
                              '&:hover': {
                                transform: 'scale(1.02)',
                                transition: 'transform 0.2s ease-in-out'
                              }
                            }}
                          >
                            <Box
                              component="img"
                              sx={{
                                height:  { xs: '25vh', sm: '25vh', md: '35vh' },
                                width:  { xs: '25vh', sm: '25vh', md: '35vh' },
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Adds a subtle shadow
                              }}
                              alt="Banner"
                              src={bannerStatus ? initialBanner.image.filename : initialBanner.img}
                              borderRadius={1.5}
                            />
                            <Box 
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                pl: { xs: 1, sm: 1.5, md: 2 }
                              }}
                            >
                              <Icon 
                                icon='si:double-arrow-right-duotone'
                                color='#55abed'
                                style={{ 
                                  fontSize: 'calc(30px + 1vw)',  // Responsive size based on viewport width
                                  marginBottom: { xs: '3px', sm: '4px', md: '5px' }
                                }}
                              />
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: '10px', sm: '12px', md: '18px' },
                                  color: '#55abed',
                                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
                                }}
                              >
                                See More
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </>
                    )}
                  </Box>
                <HelpButton />
              </Grid>
            </Box>
            <Dialog open={openWorkmateTimein} onClose={handleCloseWorkmateTimein} disableScrollLock={true}>
              <DialogTitle>
                Workmate Scan?
                <IconButton
                  aria-label="close"
                  onClick={handleCloseWorkmateTimein}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <>
{/*                  {browserName.includes('Safari') ? (
                    <>
                      <NewFeatureDialog />
                    </>
                  ) : (
                    ''
                  )}*/}
                  {!validated ? (
                    <FormControlLabel
                      style={{width: '250px', heigth: '200px'}}
                      control={<Checkbox />}
                      onChange={(e) => handleCheckboxChange(e)}
                      label="By checking this you guarantee the presence of your workmate in the vicinity using this time-in."
                    />
                  ) : (
                    <>
                      {!value ? (
                        <>
                          <QrReader
                            ref={qrReaderRef}
                            delay={qrReaderDelay}
                            onScan={handleScan}
                            onError={handleQrReaderError}
                            onLoad={handleQrReaderLoad}
                            legacyMode={qrReaderLegacyMode}
                            constraints={qrReaderConstraints}
                            style={{width: '250px', height: '200px'}}
                          />
                          {qrReaderLegacyMode && (
                            <Box sx={{mt: 1, textAlign: 'center'}}>
                              <Typography variant="caption" color="error">
                                {qrReaderErrorMessage}
                              </Typography>
                              <Button
                                size="small"
                                variant="outlined"
                                sx={{mt: 1}}
                                onClick={() => {
                                  if (qrReaderRef.current?.openImageDialog) {
                                    qrReaderRef.current.openImageDialog()
                                  }
                                }}
                              >
                                Upload QR Image
                              </Button>
                              <Button
                                size="small"
                                variant="text"
                                sx={{mt: 1, display: 'block', mx: 'auto'}}
                                onClick={() => {
                                  resetQrReaderState()
                                }}
                              >
                                Retry Camera
                              </Button>
                            </Box>
                          )}
                          <DialogTitle style={{display: 'flex', justifyContent: 'center'}}>{scanMessage}</DialogTitle>
                        </>
                      ) : (
                        <>
                          {ls.get("confirmStatus") && ls.get("confirmStatus") === "true" ? (
                            // <>
                            //   <FormControlLabel
                            //     style={{width: '100%', heigth: '200px'}}
                            //     control={<Checkbox />}
                            //     onChange={(e) => setCheckboxChange(e.target.checked)}
                            //     label={checklists[0]}
                            //   />
                            //   <br />
                            //   <FormControlLabel
                            //     style={{width: '100%', heigth: '200px'}}
                            //     control={<Checkbox />}
                            //     onChange={(e) => setUniformCheckboxChange(e.target.checked)}
                            //     label={checklists[1]}
                            //   />
                            //   <br />
                            //   <FormControlLabel
                            //     style={{width: '100%', heigth: '200px'}}
                            //     control={<Checkbox />}
                            //     onChange={(e) => setNameplateCheckboxChange(e.target.checked)}
                            //     label={checklists[2]}
                            //   />
                            //   <br />
                            //   <FormControlLabel
                            //     style={{width: '100%', heigth: '200px'}}
                            //     control={<Checkbox />}
                            //     onChange={(e) => setGroomingCheckboxChange(e.target.checked)}
                            //     label={checklists[3]}
                            //   />
                            //   <br />
                            //   <FormControlLabel
                            //     style={{width: '100%', heigth: '200px'}}
                            //     control={<Checkbox />}
                            //     onChange={(e) => setVacCheckboxChange(e.target.checked)}
                            //     label={checklists[4]}
                            //   />
                            //   <br />
                            //   <br />
                            //   <label style={{fontWeight: 'bold'}}>
                            //     Note: Telling false testimonies corresponds to a DISMISSAL
                            //   </label>
                            // </>
                            <>
                              <DialogContent>
                                <Typography variant="body1">
                                  <p>I hereby testify that I was physically present
                                  within my assigned workplace, completed my tasks, maintained an organized workspace, and have a starry smile 😊✨. </p><br/>

                                  <p>By clicking <strong>"Acknowledge"</strong>, I affirm this statement's accuracy and understand that false testimony may lead to <strong>disciplinary action, including dismissal.</strong></p>
                                </Typography>
                                <DialogActions sx={{ justifyContent: 'center', mt: 4 }}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setAcknowledged(true)}
                                    sx={{py: 1, px: 4}}
                                  >
                                    Acknowledge
                                  </Button>
                                </DialogActions>
                                
                              </DialogContent>
                            </>
                          ) : (
                            <>
                              <Box style={{width: '100%', 'margin-bottom': '25px'}} hidden={dialogStatus}>
                                <label>
                                  Hi {qrUser.displayName} please take a selfie with Team Supervisor or Manager
                                  representative with you.
                                </label>
                                <br />
                                <br />
                                <label style={{fontWeight: 'bold', color: 'red'}}>
                                  Note: If the image displays a blank screen, please click the re-capture button.
                                </label>
                              </Box>
                              <Box style={{width: '100%', 'margin-bottom': '25px'}} playsInline hidden={successStatus}>
                                <label style={{fontWeight: 'bold'}}>
                                  {curStatus} success this page will close in 5 seconds or you can choose to close it
                                  manually.
                                </label>
                              </Box>
                              <Box style={{width: '100%'}} hidden={captureStatus}>
                                <Button
                                  style={{
                                    width: '100%',
                                    backgroundColor: (isCameraOutputMissing || waitingForCamera) ? '#bdbdbd' : '#1F98E8',
                                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.35)',
                                    color: 'white',
                                  }}
                                  onClick={takePicture}
                                  variant="contained"
                                  sx={{borderRadius: 28}}
                                  disabled={isCameraOutputMissing || waitingForCamera}
                                >
                                  {waitingForCamera ? 'Waiting for camera...' : `Capture ${countdown}`}
                                </Button>
                                {(isCameraOutputMissing || waitingForCamera || qrReaderRetryCount > 0) && !captureStatus && (
                                  <Typography
                                    variant="caption"
                                    sx={{display: 'block', mt: 1, color: 'text.secondary', textAlign: 'center'}}
                                  >
                                    {waitingForCamera
                                      ? 'Waiting for camera feed. Capture will happen automatically once ready.'
                                      : qrReaderRetryCount > 0
                                      ? 'Retrying camera connection. Please wait...'
                                      : 'Waiting for camera output. Capture will enable once the feed is visible.'}
                                  </Typography>
                                )}
                              </Box>
                              <br />
                              <Box style={{position: 'relative', width: '100%', minHeight: '300px'}} hidden={captureStatus}>
                                <video
                                  ref={videoRef}
                                  style={{width: '100%', height: '100%', display: (isCameraOutputMissing || waitingForCamera) ? 'none' : 'block'}}
                                  src="something"
                                  type="video/mp4"
                                  playsInline
                                ></video>
                                {(isCameraOutputMissing || waitingForCamera) && (
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: '#f5f5f5',
                                      minHeight: '300px'
                                    }}
                                  >
                                    <Loading />
                                  </Box>
                                )}
                              </Box>
                              <canvas
                                id="canvas"
                                style={{width: '100%', height: '100%'}}
                                ref={photoRef}
                                hidden={timeinStatus}
                              ></canvas>

                              {isLoading ? (
                                <Box style={{width: '100%', 'margin-bottom': '15px'}} hidden={timeinStatus}>
                                  <Loading />
                                </Box>
                              ) : (
                                <div style={{height: '100%'}}>
                                  <Box style={{width: '100%', marginTop: '15px'}} hidden={timeinStatus}>
                                    <Button
                                      style={{width: '100%'}}
                                      onClick={handleTimein}
                                      variant="contained"
                                      sx={{borderRadius: 28}}
                                    >
                                      {curStatus} {countdown}
                                    </Button>
                                  </Box>
                                  <br />
                                  <Box style={{width: '100%'}} hidden={timeinStatus}>
                                    <Button
                                      style={{width: '100%'}}
                                      onClick={clearImage}
                                      variant="contained"
                                      sx={{borderRadius: 28}}
                                    >
                                      Re-capture
                                    </Button>
                                  </Box>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              </DialogContent>
            </Dialog>
            <Dialog
              open={openCurrentShift}
              onClose={handleCurrentShiftClose}
              classes={{paperScrollPaper: classes.customWidth}}
              disableScrollLock={true}
            >
              <DialogTitle>
                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                  <Typography variant="h6" sx={{textAlign: 'start'}}>
                    {' '}
                    Employee:{' '}
                  </Typography>
                  <Typography variant="h6" sx={{textAlign: 'end'}}>
                    {basicUser ? basicUser.displayName : 'Loading'}
                  </Typography>
                </Box>
              </DialogTitle>
              <DialogContent>
                <hr />
                <Box key={basicUser._id} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <Box>
                    <Typography>Time in</Typography>
                    <Box sx={{display: 'flex', gap: 3}}>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecord ? filterByStatus(currentRecord.record, 'time-in').time : '00:00'}{' '}
                      </Typography>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecordDate ? currentRecordDate : 'No Record'}
                      </Typography>
                    </Box>
                    <Typography variant="caption"> {currentRecord ? currentRecord._id : 'Loading'} </Typography>
                  </Box>
                </Box>
                <hr />
                <Box key={basicUser._id} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <Box>
                    <Typography>Break in</Typography>
                    <Box sx={{display: 'flex', gap: 3}}>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecord ? filterByStatus(currentRecord.record, 'break-in').time : '00:00'}{' '}
                      </Typography>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecordDate ? currentRecordDate : 'No Record'}
                      </Typography>
                    </Box>
                    <Typography variant="caption"> {currentRecord ? currentRecord._id : 'Loading'} </Typography>
                  </Box>
                </Box>
                <hr />
                <Box key={basicUser._id} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <Box>
                    <Typography>Break out</Typography>
                    <Box sx={{display: 'flex', gap: 3}}>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecord ? filterByStatus(currentRecord.record, 'break-out').time : '00:00'}{' '}
                      </Typography>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecordDate ? currentRecordDate : 'No Record'}
                      </Typography>
                    </Box>
                    <Typography variant="caption"> {currentRecord ? currentRecord._id : 'Loading'} </Typography>
                  </Box>
                </Box>
                <hr />
                <Box key={basicUser._id} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <Box>
                    <Typography>Time out</Typography>
                    <Box sx={{display: 'flex', gap: 3}}>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecord ? filterByStatus(currentRecord.record, 'time-out').time : '00:00'}{' '}
                      </Typography>
                      <Typography variant="subtitle2">
                        {' '}
                        {currentRecordDate ? currentRecordDate : 'No Record'}
                      </Typography>
                    </Box>
                    <Typography variant="caption"> {currentRecord ? currentRecord._id : 'Loading'} </Typography>
                  </Box>
                </Box>
                <hr />
                <Box
                  key={basicUser._id}
                  sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                  style={{'margin-top': '.5rem'}}
                >
                  <Box sx={{display: 'flex', justifyContent: 'start'}}>
                    <Typography color="green"> Recorded </Typography>
                  </Box>
                  <Box sx={{display: 'flex', justifyContent: 'end'}}>
                    <Button
                      variant="warning"
                      size="small"
                      style={{backgroundColor: 'red'}}
                      onClick={handleCurrentShiftClose}
                    >
                      {' '}
                      <Typography variant="caption"> Close </Typography>{' '}
                    </Button>
                  </Box>
                </Box>
              </DialogContent>
            </Dialog>
            <Dialog open={openTimein} onClose={handleCloseTimein} disableScrollLock={true}>
              <DialogTitle>
                {curStatus}
                <IconButton
                  aria-label="close"
                  onClick={handleCloseTimein}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
{/*                {browserName.includes('Safari') ? (
                  <>
                    <NewFeatureDialog />
                  </>
                ) : (
                  ''
                )}*/}

                <>
                  {false ? (
                    // <>
                    //   <FormControlLabel
                    //     style={{width: '100%', heigth: '200px'}}
                    //     control={<Checkbox />}
                    //     onChange={(e) => checkAll(e.target.checked)}
                    //     label="Check All"
                    //   />
                    //   <br />
                    //   <FormControlLabel
                    //     style={{width: '100%', heigth: '200px'}}
                    //     control={
                    //       <Checkbox 
                    //         checked={checkBoxChange}
                    //       />
                    //     }
                    //     onChange={(e) => setCheckboxChange(e.target.checked)}
                    //     label={checklists[0]}
                    //   />
                    //   <br />
                    //   <FormControlLabel
                    //     style={{width: '100%', heigth: '200px'}}
                    //     control={
                    //       <Checkbox 
                    //         checked={uniformCheckboxChange}
                    //       />
                    //     }
                    //     onChange={(e) => setUniformCheckboxChange(e.target.checked)}
                    //     label={checklists[1]}
                    //   />
                    //   <br />
                    //   <FormControlLabel
                    //     style={{width: '100%', heigth: '200px'}}
                    //     control={<Checkbox 
                    //         checked={nameplateCheckBoxChange}
                    //       />}
                    //     onChange={(e) => setNameplateCheckboxChange(e.target.checked)}
                    //     label={checklists[2]}
                    //   />
                    //   <br />
                    //   <FormControlLabel
                    //     style={{width: '100%', heigth: '200px'}}
                    //     control={<Checkbox 
                    //         checked={groomingCheckboxChange}
                    //       />}
                    //     onChange={(e) => setGroomingCheckboxChange(e.target.checked)}
                    //     label={checklists[3]}
                    //   />
                    //   <br />
                    //   <FormControlLabel
                    //     style={{width: '100%', heigth: '200px'}}
                    //     control={<Checkbox 
                    //         checked={vacCheckBoxChange}
                    //       />}
                    //     onChange={(e) => setVacCheckboxChange(e.target.checked)}
                    //     label={checklists[4]}
                    //   />
                    //   <br />
                    //   <br />
                    //   <label style={{fontWeight: 'bold'}}>
                    //     Note: Telling false testimonies corresponds to a DISMISSAL
                    //   </label>
                    // </>
                      <>
                        <DialogContent>
                          <Typography variant="body1">
                            <p>I hereby testify that I was physically present
                            within my assigned workplace, completed my tasks, maintained an organized workspace, and have a starry smile 😊✨. </p><br/>

                            <p>By clicking <strong>"Acknowledge"</strong>, I affirm this statement's accuracy and understand that false testimony may lead to <strong>disciplinary action, including dismissal.</strong></p>
                          </Typography>
                          <DialogActions sx={{ justifyContent: 'center', mt: 4 }}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => setAcknowledged(true)}
                              sx={{py: 1, px: 4}}
                            >
                              Acknowledge
                            </Button>
                          </DialogActions>
                          
                        </DialogContent>
                      </>
                  ) : (
                    <div id="pageContainer">
                      <Box style={{width: '100%', 'margin-bottom': '25px'}} hidden={dialogStatus}>
                        <label>
                          Hi {basicUser.displayName} please take a selfie with Team Supervisor or Manager representative with
                          you.
                        </label>
                        <br />
                        <br />
                        <label style={{fontWeight: 'bold', color: 'red'}}>
                          Note: If the image displays a blank screen, please click the re-capture button.
                        </label>
                      </Box>
                      <Box
                        style={{width: '100%', 'margin-bottom': '25px'}}
                        hidden={successStatus}
                        playsInline
                        type="video/mp4"
                      >
                        <label style={{fontWeight: 'bold'}}>
                          {curStatus} success this page will close in 5 seconds or you can choose to close it manually.
                        </label>
                      </Box>
                      <Box style={{width: '100%'}} hidden={captureStatus}>
                        <Button
                          style={{
                            width: '100%',
                            backgroundColor: (isCameraOutputMissing || waitingForCamera) ? '#bdbdbd' : '#1F98E8',
                            boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.35)',
                            color: 'white',
                          }}
                          onClick={takePicture}
                          variant="contained"
                          sx={{borderRadius: 28}}
                          disabled={isCameraOutputMissing || waitingForCamera}
                        >
                          {waitingForCamera ? 'Waiting for camera...' : `Capture ${countdown}.`}
                        </Button>
                      {(isCameraOutputMissing || waitingForCamera || qrReaderRetryCount > 0) && !captureStatus && (
                          <Typography
                            variant="caption"
                            sx={{display: 'block', mt: 1, color: 'text.secondary', textAlign: 'center'}}
                          >
                          {waitingForCamera
                            ? 'Waiting for camera feed. Capture will happen automatically once ready.'
                            : qrReaderRetryCount > 0
                            ? 'Retrying camera connection. Please wait...'
                            : 'Waiting for camera output. Capture will enable once the feed is visible.'}
                          </Typography>
                        )}
                      </Box>
                      <br />
                      <Box style={{position: 'relative', width: '100%', minHeight: '300px'}} hidden={captureStatus}>
                        <video
                          ref={videoRef}
                          style={{width: '100%', height: '100%', display: (isCameraOutputMissing || waitingForCamera) ? 'none' : 'block'}}
                          src="something"
                          type="video/mp4"
                          playsInline
                        ></video>
                        {(isCameraOutputMissing || waitingForCamera) && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#f5f5f5',
                              minHeight: '300px'
                            }}
                          >
                            <Loading />
                          </Box>
                        )}
                      </Box>
                      <canvas
                        id="canvas"
                        style={{width: '100%', height: '100%'}}
                        ref={photoRef}
                        hidden={timeinStatus}
                      ></canvas>
                      {isLoading ? (
                        <Loading />
                      ) : (
                        <>

                          <Box style={{width: '100%', marginTop: '15px'}} hidden={timeinStatus}>
                            <Button
                              style={{width: '100%'}}
                              onClick={handleTimein}
                              variant="contained"
                              sx={{borderRadius: 28}}
                            >
                              {curStatus}
                            </Button>
                          </Box>
                          <Box style={{width: '100%', marginTop: '15px'}} hidden={timeinStatus}>
                            <Button
                              style={{width: '100%'}}
                              onClick={clearImage}
                              variant="contained"
                              sx={{borderRadius: 28}}
                            >
                              Re-capture
                            </Button>
                          </Box>
                        </>
                      )}
                    </div>
                  )}
                </>
              </DialogContent>
            </Dialog>
            <Dialog open={openOtherStore} onClose={() => handleOpenStore()} disableScrollLock={true}>
              <DialogTitle>
                Scan Store QR Code
                <IconButton
                  aria-label="close"
                  onClick={handleCloseOtherStore}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
{/*                {browserName.includes('Safari') ? (
                  <>
                    <NewFeatureDialog />
                  </>
                ) : (
                  ''
                )}*/}
                {!checkOtherStore ? (
                  <Box>
                    <FormControlLabel
                      control={<Checkbox checked={checkOtherStore} onChange={handleCheckboxChangeStore} />}
                      label="By checking this you guarantee that you are rendering a duty to this store."
                    />
                  </Box>
                ) : (
                  <>
                    {!value ? (
                      <>
                        <QrReader
                          delay={3000}
                          onError={handleError}
                          onScan={handleScan}
                          videoConstraints={{facingMode: "environment"}}
                          // chooseDeviceId={()=>selected}
                          style={{width: '250px', heigth: '200px'}}
                          // className={'qrScanner'}
                        />
                        <DialogTitle style={{display: 'flex', justifyContent: 'center'}}>{scanMessage}</DialogTitle>
                      </>
                    ) : (
                      <>
                        {true && (
                          // <>
                          //   <label style={{fontWeight: 'bold'}}>
                          //     I testify that I am in front of the TS and management representative upon signing in.{' '}
                          //     <br />
                          //     Also, I signify that I have:
                          //   </label>
                          //   <br />
                          //   <FormControlLabel
                          //     style={{width: '250px', heigth: '200px', 'margin-top': '20px'}}
                          //     control={<Checkbox />}
                          //     onChange={(e) => setUniformCheckboxChange(e.target.checked)}
                          //     label={dummyStoreCheckList[0]}
                          //   />
                          //   <br />
                          //   <FormControlLabel
                          //     style={{width: '250px', heigth: '200px'}}
                          //     control={<Checkbox />}
                          //     onChange={(e) => setNameplateCheckboxChange(e.target.checked)}
                          //     label={dummyStoreCheckList[1]}
                          //   />
                          //   <br />
                          //   <FormControlLabel
                          //     style={{width: '250px', heigth: '200px'}}
                          //     control={<Checkbox />}
                          //     onChange={(e) => setGroomingCheckboxChange(e.target.checked)}
                          //     label={dummyStoreCheckList[2]}
                          //   />
                          //   <br />
                          //   <FormControlLabel
                          //     style={{width: '250px', heigth: '200px'}}
                          //     control={<Checkbox />}
                          //     onChange={(e) => setVacCheckboxChange(e.target.checked)}
                          //     label={dummyStoreCheckList[3]}
                          //   />
                          //   <br />
                          //   <br />
                          //   <label style={{fontWeight: 'bold'}}>
                          //     Note: Telling false testimonies corresponds to a DISMISSAL
                          //   </label>
                          // </>
                          <>
                            <DialogContent>
                              <Typography variant="body1">
                                <p>I hereby testify that I was physically present
                                within my assigned workplace, completed my tasks, maintained an organized workspace, and have a starry smile 😊✨. </p><br/>

                                <p>By clicking <strong>"Acknowledge"</strong>, I affirm this statement's accuracy and understand that false testimony may lead to <strong>disciplinary action, including dismissal.</strong></p>
                              </Typography>
                              <DialogActions sx={{ justifyContent: 'center', mt: 4 }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => setAcknowledged(true)}
                                  sx={{py: 1, px: 4}}
                                >
                                  Acknowledge
                                </Button>
                              </DialogActions>
                              
                            </DialogContent>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </DialogContent>
            </Dialog>
            <Dialog open={openCreateScheduleDialog} onClose={() => setOpenCreateScheduleDialog(false)} fullWidth maxWidth="xs" disableScrollLock={true}>
              <IconButton
                aria-label="close"
                onClick={handleCloseCreateScheduleDialog}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
              <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
                {isEditingExistingSchedule ? "Edit Schedule" : "Create Schedule"}
              </DialogTitle>
              <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <TextField
                  label="Time-in"
                  type="time"
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  value={from}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{ sx: { fontSize: "0.9rem" }, step: 300 }}
                  onChange={(e) => setFrom(e.target.value)}
                />
                <TextField
                  label="Time-out"
                  fullWidth
                  type="time"
                  variant="outlined"
                  margin="dense"
                  value={to}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{ sx: { fontSize: "0.9rem" }, step: 300 }}
                  onChange={(e) => setTo(e.target.value)}
                />
                <TextField
                  label="No. of breaks (mins)"
                  fullWidth
                  type="number"
                  variant="outlined"
                  margin="dense"
                  value={breakMin}
                  onChange={(e) => setBreakMin(e.target.value)}
                />
                <TextField
                  label="Position"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={position}
                  margin="dense"
                  onChange={(e) => setPosition(e.target.value)}
                />
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  variant="contained"
                  onClick={handleSaveSchedule}
                  sx={{
                    backgroundColor: "#2194F3",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    fontWeight: "bold",
                    color: "white",
                    "&:hover": { backgroundColor: "#1976D2" },
                  }}
                >
                  {isEditingExistingSchedule ? "Update" : "Save"}
                </Button>
              </DialogActions>
            </Dialog>
        </>
      ) : (
        <FacebookDialog permitted={open} />
      )}
      {/* {selected && (
        <Dialog
          open={selected}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          disableScrollLock={true}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          sx={{overflow: 'hidden'}}
        >
          <DialogContent sx={{p: 0, height: '50vh', overflow: 'hidden'}}>
            <Box component="img" src={selectedBanner} sx={{height: '100%', width: '100px', objectFit: 'cover'}} />
          </DialogContent>
          <DialogActions
            sx={{
              mb: -10,
              textAlign: 'center',
              bgColor: 'rgba(255,255,255,0)',
              zIndex: 20,
              position: 'absolute',
              top: 0,
              right: -15
            }}
          >
            <Button onClick={handleClose} color="primary" sx={{mx: 'auto'}}>
              <HighlightOffIcon sx={{color: 'common.white', fontSize: 32}} />
            </Button>
          </DialogActions>
        </Dialog>
      )}*/}

      <DemoRestrictionDialog
        open={demoDialogOpen}
        onClose={() => setDemoDialogOpen(false)}
      />

      <Dialog open={tooEarlyDialogOpen} onClose={() => setTooEarlyDialogOpen(false)} sx={{ textAlign: "center" }} disableScrollLock={true}>
        <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 1 }}>
            <Icon icon="mdi:alert-circle" style={{ color: "#FF6B6B", fontSize: "2rem" }} />
          </Box>
          <Typography variant="h6" fontWeight="bold" color="error.main">
            Too Early!
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, textAlign: "center" }}>
            Confirm your shift within 2 hours before start time. Try again later, or adjust your schedule now.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            onClick={() => setTooEarlyDialogOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#2194F3",
              borderRadius: "8px",
              padding: "12px 24px",
              fontWeight: "bold",
              color: "white",
              "&:hover": { backgroundColor: "#1976D2" }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={updateDialogOpen} onClose={() => setUpdateDialogOpen(false)} disableScrollLock={true}>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            The app has been updated
          </Typography>
        </DialogTitle>
        <DialogContent>Your app has been updated to the latest version. Enjoy improved performance and new features!</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUpdateDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAcknowledgement} onClose={() => {
        setOpenAcknowledegment(false)
        setIsScheduleConfirmation(false)
      }} disableScrollLock={true}>
        <DialogContent>
          <Typography variant="body1">
            <p>I hereby testify that I was physically present
            within my assigned workplace, completed my tasks, maintained an organized workspace, and have a starry smile 😊✨. </p><br/>

            <p>By clicking <strong>"Acknowledge"</strong>, I affirm this statement's accuracy and understand that false testimony may lead to <strong>disciplinary action, including dismissal.</strong></p>
          </Typography>
          <DialogActions sx={{ justifyContent: 'center', mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAcknowledge()}
              sx={{py: 1, px: 4}}
            >
              Acknowledge
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog open={confirmScheduleDialog} onClose={() => setConfirmScheduleDialog(false)} sx={{ textAlign: "center" }} disableScrollLock={true}>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Please confirm your schedule
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            You need to confirm your assigned schedule before you can Time in. Check your <strong>My Schedule</strong>, review your shift, and click <strong>Confirm Schedule</strong> to proceed!
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            <strong>Note:</strong> You can only confirm your schedule within 2 hours before your scheduled shift start time. If it's too early, please refresh the page once you're within the 2-hour window.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button 
            onClick={() => setConfirmScheduleDialog(false)} 
            variant="contained" 
            sx={{ 
              backgroundColor: "#2194F3", 
              borderRadius: "8px", 
              padding: "8px 16px", 
              fontWeight: "bold",
              marginBottom: "20px",
              color: "white", 
              "&:hover": { backgroundColor: "#1976D2" } // Slightly darker on hover
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={noScheduleDialog} onClose={() => setNoScheduleDialog(false)} sx={{ textAlign: "center" }} disableScrollLock={true}>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            No Schedule Found
          </Typography>
        </DialogTitle>
        <DialogContent>You don't have a schedule yet. Please <strong>input your schedule</strong> first to proceed.</DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button 
            onClick={() => {
              setNoScheduleDialog(false);
              window.location.reload();
            }}
            variant="contained" 
            sx={{ 
              backgroundColor: "#2194F3", 
              borderRadius: "8px", 
              padding: "8px 16px", 
              fontWeight: "bold",
              marginBottom: "20px",
              color: "white", 
              "&:hover": { backgroundColor: "#1976D2" } // Slightly darker on hover
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={saveScheduleSuccess} onClose={() => setSaveScheduleSuccess(false)} sx={{ textAlign: "center" }} disableScrollLock={true}>
        <IconButton
          aria-label="close"
          onClick={() => setSaveScheduleSuccess(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            {isEditingExistingSchedule ? "Schedule updated!" : "Schedule created!"}
          </Typography>
        </DialogTitle>
        <DialogContent>Please scan store QR Code to finalize your {isEditingExistingSchedule ? "schedule update" : "schedule for today"}.</DialogContent>
        <DialogActions sx={{ flexDirection: "column", alignItems: "center" }}>
          <QrReader
            delay={3000}
            onError={handleError}
            onScan={handleConfirmScheduleScan}
            videoConstraints={{facingMode: "environment"}}
            style={{ width: '250px', height: '200px' }}
          />
          <Button 
            variant="contained" 
            color="primary" 
            sx={{ mt: 8 }} 
            onClick={handleOpenOtpDialog}
          >
            Try another way
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={otpDialog} onClose={() => setOtpDialog(false)} sx={{ textAlign: "center" }} disableScrollLock={true}>
        <IconButton
          aria-label="close"
          onClick={() => setOtpDialog(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Please input OTP generated through the store account!
          </Typography>
        </DialogTitle>
        <DialogContent>
          Please Enter the OTP generated from your store manager's account
          <br />
          <br />
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={<span>-</span>}
              renderInput={(props) => <input {...props}
                style={{
                  width: '35px', // Adjust the width as needed
                  height: '40px', // Adjust the height as needed
                  fontSize: '16px', // Adjust the font size as needed
                  margin: '0 5px', // Adjust the margin as needed
                  padding: '5px', // Adjust the padding as needed
                  textAlign: 'center', // Center the text inside the box
                }}
              />}
            />
            <Button sx={{ ml: 3, mt: 5 }} variant="contained" onClick={handleSubmitOtp}>Submit OTP</Button>
          </Box>
          <br />
        </DialogContent>
      </Dialog>

      <Dialog 
        open={openConfirmScheduleDialog} 
        onClose={() => setOpenConfirmScheduleDialog(false)} 
        sx={{ textAlign: "center" }}
        disableScrollLock={true}
      >
        <DialogContent 
          sx={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: 3,
            textAlign: "center",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setOpenConfirmScheduleDialog(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" fontWeight="bold" sx={{ color: "limegreen" }}>
            Schedule Confirmed
          </Typography>
          <Typography variant="body1" sx={{ marginTop: "10px" }}>
            Please time out on time to ensure proper counting of your manhours
          </Typography>
          <Typography variant="body2" sx={{ marginTop: '10px', fontWeight: 'bold' }}>
            This message will close in {countdown} second{countdown !== 1 ? 's' : ''}.
          </Typography>
        </DialogContent>
      </Dialog>

      <Dialog open={openSetOTDialog} onClose={() => setOpenSetOTDialog(false)} fullWidth maxWidth="xs" disableScrollLock={true}>
        <IconButton
          aria-label="close"
          onClick={(handleCloseSetOpenSetOTDialog)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>Premium Values</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Choose Date"
            type="date"
            fullWidth
            variant="outlined"
            margin="dense"
            value={selectedDate} // Ensure this state is correctly initialized
            InputLabelProps={{
              shrink: true, // Ensures label stays above when date is selected
            }}
            InputProps={{ sx: { fontSize: "0.9rem" }, step: 300 }}
            onChange={(e) => setSelectedDate(e.target.value)} // Fix this line
          />
          <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
            <FormControl sx={{ width: "50%" }} margin="dense" variant="outlined">
              <InputLabel shrink>Overtime (Hours)</InputLabel>
              <Select
                value={otHours}
                onChange={(e) => handleChangeOtHours(e.target.value)}
                label="Overtime (Hours)"
              >
                {[...Array(25)].map((_, i) => (
                  <MenuItem key={i} value={i}>
                    {i}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: "50%" }} margin="dense">
              <InputLabel shrink>Overtime (Minutes)</InputLabel>
              <Select value={otMinutes} onChange={(e) => handleChangeOtMinutes(e.target.value)} label="Overtime (Minutes)" variant="outlined">
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
            <FormControl sx={{ width: "50%" }} margin="dense">
              <InputLabel>NSD (Hours)</InputLabel>
              <Select value={nsdHours} onChange={(e) => handleChangeNsdHours(e.target.value)} variant="outlined">
                {[...Array(9)].map((_, i) => (
                  <MenuItem key={i + 0} value={i + 0}>
                    {i + 0}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ width: "50%" }} margin="dense">
              <InputLabel>NSD (Minutes)</InputLabel>
              <Select value={nsdMinutes} onChange={(e) => handleChangeNsdMinutes(e.target.value)} variant="outlined">
                <MenuItem value={0}>0</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
{/*          <TextField
            label="NSD (10pm - 6am - Hours)"
            fullWidth
            type="number"
            variant="outlined"
            margin="dense"
            value={nsd}
            onChange={(e) => setNsd(e.target.value)}
          />*/}
          <Typography variant="body2" sx={{ color: "#333", fontStyle: "italic", mt: -1 }}>
            <strong>Note: Please ensure you secure approval first before clicking the Save button.</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={handleSaveOT}
            sx={{
              backgroundColor: "#2194F3",
              borderRadius: "8px",
              padding: "8px 16px",
              fontWeight: "bold",
              color: "white",
              "&:hover": { backgroundColor: "#1976D2" },
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={savePremiumDialog} onClose={() => setSavePremiumDialog(false)} sx={{ textAlign: "center" }} disableScrollLock={true}>
        <IconButton
          aria-label="close"
          onClick={() => setSavePremiumDialog(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Premium value request created!
          </Typography>
        </DialogTitle>
        <DialogContent>Please scan store QR Code to finalize your OT request.</DialogContent>
        <DialogActions sx={{ flexDirection: "column", alignItems: "center" }}>
          <QrReader
            delay={3000}
            onError={handleError}
            onScan={handleConfirmPremiumScan}
            videoConstraints={{facingMode: "environment"}}
            style={{ width: '250px', height: '200px' }}
          />
          <Button 
            variant="contained" 
            color="primary" 
            sx={{ mt: 8 }} 
            onClick={handleOpenOtpDialog}
          >
            Try another way
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add the My Time Record section after Bulletin Board */}
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" mt={4} mb={2} mx={1}>
        <Box display="flex" justifyContent="space-between" width="100%" mb={2} alignItems="center">
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            My History
          </Typography>
          <Button
            onClick={() => navigate('/dashboard/app/my-history')}
            variant="contained"
            startIcon={<ArrowForwardIosIcon fontSize="small" />}
            sx={{
              borderRadius: "8px",
              backgroundColor: "#2194F3",
              color: "white",
              '&:hover': {
                backgroundColor: '#1976D2',
              },
              textTransform: 'none'
            }}
          >
            View All
          </Button>
        </Box>

        {loadingRecords ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
            <CircularProgress />
          </Box>
        ) : recentRecords && recentRecords.length > 0 ? (
          recentRecords.map((record) => renderHistoryCard(record))
        ) : (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: 200,
            border: '1px dashed #ccc',
            borderRadius: '8px',
            width: '100%'
          }}>
            <Typography color="text.secondary">No recent records available</Typography>
          </Box>
        )}
      </Box>

      {/* Dice Game Dialog */}
      {diceGameDialog && (
        <DiceGameDialog
          open={diceGameDialog}
          onClose={() => setDiceGameDialog(false)}
          userId={basicUser._id}
          userName={`${basicUser.firstName || ''} ${basicUser.lastName || ''}`.trim() || basicUser.displayName}
          userCompany={basicUser.company}
        />
      )}

    </Page>
  )
}

export default DashboardApp
